/* eslint-disable */
import './ThreeMonitor.css';
import React, { Component } from 'react';
import * as THREE from 'three';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import SteeringWheel from './images/SteeringWheel.png';
import START from './images/start.png';
import END from './images/end.png';
import MISC from './images/misc.png';
import CAR from './images/car.png';
import PEDESTRIAN from './images/PEDESTRIAN.png';
import CYCLIST from './images/CYCLIST.png';
import TRUCK from './images/TRUCK.png';
import BUS from './images/BUS.png';
import TRAFFIC_CONE from './images/traffic-cone.png';
import ROAD_SEWER from './images/road_sewer.png';
import TRICYCLE from './images/TRICYCLE.png';
import NONE from './images/NONE.png';
import POLE from './images/pole.png';
import JD_VEHICLE from './images/jd_vehicle.png';
import OTHER_VEHICLE from './images/other_vehicle.png';
import STOP_LIGHT_ON from './images/STOP_LIGHT_ON.png';
import STOP_LIGHT_OFF from './images/STOP_LIGHT_OFF.png';
import TRAFFIC_LIGHT from './images/traffic_light.png';
import RETRSCT from './images/retract.png';
import CLEARDAY from './images/clearday.png';
import EXPAND from './images/expand.png';
import SNOW from './images/snow.png';
import RAIN from './images/rain.png';
import DAY from './images/day.png';
import NIGHT from './images/night.png';
import CONSTRUCTION from './images/construction.png';
import ACCUMULATED_WATEWR from './images/accumulated_water.png';
import BRAKE from './images/brake.png';
import NODATA from './images/no_data.png';

import TOP from './images/top.png';
import BUTTOM from './images/bottom.png';
import WebsocketCmp from '../../WebsocketCmp';
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
const protobuf = require('protobufjs');
import { decompress as zstdDecompress } from 'fzstd';
import { Form, Switch } from 'antd';
const local_view_json = require('../proto/local_view.json');
const local_view_root = protobuf.Root.fromJSON(local_view_json);
const local_view_type = local_view_root.lookupType(
  'jdx.rover.hermes.dto.LocalViewDTO'
);

class ThreeMonitor extends Component {
  constructor(props) {
    super(props);
    this.app = this;
    this.camera = null;
    this.scene = null;
    this.quaternion_vehicle = new THREE.Quaternion(0, 0, 0, 1);
    this.current_x = 0;
    this.current_y = 0;
    this.current_yaw = 0;
    this.camera_flag = 1;
    this.texture_cube = [];
    this.camera_scale_follow = 30;
    this.camera_scale_top = 30;
    this.car_mesh = undefined;
    this.pose_last = null;
    this.controls = null;
    this.fps = 10;
    this.material_lane = new THREE.LineBasicMaterial({ color: 0x339900 });
    this.group_lanes = new THREE.Group();
    this.group_boundaries = new THREE.Group();
    this.groupStopLine = new THREE.Group();
    this.group_noise_point = new THREE.Group();
    this.groupParkingNode = new THREE.Group();
    this.group_occ_grids = new THREE.Group();
    this.group_bev_seg = new THREE.Group();
    this.groupPerceptionTrafficLights = new THREE.Group(); // 感知红绿灯图标组
    this.group_gates = new THREE.Group(); // 门数据可视化组
    this.group_gates.renderOrder = 999; // 设置高渲染顺序,确保在其他对象之后渲染(穿透显示)
    this.group_occ_grids.renderOrder = 998; // 设置高渲染顺序,确保在其他对象之后渲染(穿透显示)
    this.container = undefined;
    this.renderer = undefined;
    this.group_obstacles = null;
    this.convex_buffer_map = new Map();
    this.cube_pillar_map = new Map();
    this.cube_label_map = new Map();
    this.cube_trajectory_map = new Map();
    this.trajectory_polygon_buffer = new Map();
    this.trajectory_buffer = new Map();
    this.planning_path_buffer = new Map();
    this.planning_path_polygon_buffer = new Map();
    this.map_material_lidar_point = new Map();
    this.noise_point_mesh = [];
    this.parkingNodes = [];
    this.routing_buffer = new Map();
    this.set_boundary_id = new Set();
    this.setStopLineId = new Set();
    this.set_lane_id = new Set();
    this.set_gate_id = new Set(); // 门ID集合
    this.now = Date.now();
    this.then = Date.now();
    this.material_icon_cube = [];
    this.material_cubes_mesh = [];
    this.material_cubes = [];
    this.deque_dataview = [];
    // 帧丢弃优化: 待解码的原始数据槽位
    this.pendingRawData = null;      // 存储最新的原始数据
    this.isDecoding = false;         // 解码锁,防止并发解码
    this.lastDecodeTime = 0;         // 上次解码时间戳(用于性能监控)

    // 外部 readiness：收到首帧并完成一次渲染后通知（用于回放自动播放对齐）
    this.__firstFramePending = false;
    this.__firstFrameNotified = false;

    // 生命周期清理句柄：卸载时必须停止 rAF 渲染循环与全局监听，
    // 否则重挂载（如回放切片段）会泄漏永久运行的渲染循环
    this._animFrame = null;
    this._mountTimer = null;
    this._keyDownHandler = null;
    this._isUnmounted = false;
    // 脏检查渲染：仅在有新数据/相机交互/外部标记时执行 renderer.render，
    // 空闲时让出主线程，避免周期性强占导致视频呈现卡顿
    this._needsRender = true;
    this._lastTextUpdateAt = 0;
    this._sizeVec = null;

    this.material_trajectory = null;
    this.lidar_master_to_base_link_trans = [0, 0, 0, 0, 0, 0]; // x, y, z, roll, pitch, yaw    // OCC grid configuration
    this.occ_grid_config = {
      x_min: -10.0,
      y_min: -20.0,
      x_size: 0.1,
      y_size: 0.1,
      x_num: 501,
      y_num: 401,
      align_to_vehicle_center: false,
      align_to_vehicle_heading: true,
    };
    this.occ_grid_plane_mesh = null;
    this.occ_grid_plane_material = null;
    this.occ_grid_texture = null;
    this.occ_grid_last_signature = null;
    this.occ_grid_pending_signature = null;
    this.occ_grid_plane_cols = null;
    this.occ_grid_plane_rows = null;
    this.debugFlag = localStorage.getItem('debug') === "true"

    // BEV segmentation result configuration
    this.bev_seg_config = {
      x_min: -30.0,   // 左右各30m
      y_min: -40.0,   // 后方40m
      x_size: 0.25,
      y_size: 0.25,
      x_num: 480,     // 左右各30m / 0.25 = 240
      y_num: 240,     // (80m前方 + 40m后方) / 0.25 = 120
      align_to_vehicle_center: false,
      align_to_vehicle_heading: true,
    };
    this.bev_seg_plane_mesh = null;
    this.bev_seg_plane_material = null;
    this.bev_seg_texture = null;
    this.bev_seg_last_signature = null;
    this.bev_seg_pending_signature = null;
    this.bev_seg_plane_cols = null;
    this.bev_seg_plane_rows = null;

    // BEV segmentation color configuration
    this.bev_seg_color_config = [
      [[255, 0, 0], 1.0],
      [[0, 255, 255], 1.0],
      [[255, 0, 255], 1.0],
      [[255, 255, 0], 1.0],
      [[255, 128, 0], 1.0],
      [[0, 128, 255], 1.0],
      [[255, 0, 128], 1.0],
      [[165, 165, 165], 0.2],
    ];

    this.sprite_end = new THREE.TextureLoader().load(END);
    this.sprite_start = new THREE.TextureLoader().load(START);

    this.material_label_start = new THREE.PointsMaterial({
      size: 50,
      sizeAttenuation: false,
      map: this.sprite_start,
      alphaTest: 0.5,
      transparent: true,
    });
    this.material_label_end = new THREE.PointsMaterial({
      size: 50,
      sizeAttenuation: false,
      map: this.sprite_end,
      alphaTest: 0.5,
      transparent: true,
    });
    this.GeometryType = {
      LINE_LOOP: 1,
      LINE_STRIP: 2,
      LINE_SEGMENT: 3,
      CONVEX: 4,
      POLYGON: 5,
      SYMBOL: 6,
    };
    this.GearState = {
      OTHER: 0,
      NEUTRAL: 1,
      DRIVE: 2,
      REVERSE: 3,
      PARKING: 4,
      LOW: 5,
      INVALID: 6,
      NONE: 7,
      SPORT: 8,
    };
    this.GeometryType = {
      LINE_LOOP: 1,
      LINE_STRIP: 2,
      LINE_SEGMENT: 3,
      CONVEX: 4,
      POLYGON: 5,
      SYMBOL: 6,
    };
    this.MultiFrameState = {
      NONE: 0,
      FLASHING_GREEN: 1,
      FLASHING_RED: 2,
      FLASHING_YELLOW: 3,
      CONTINUE_UNKNOWN: 4,
      CONTINUE_BLACK: 5,
      CONTINUE_GREEN: 6,
      CONTINUE_RED: 7,
      CONTINUE_YELLOW: 8,
    };
    this.state = {
      steerAngle: 0,
      carGearPosition: "",
      poleIsClose: false,
      text_current_frame_time: '',
      showDriveMode: true,
      showAllLight: false,
      show_global_config: true,
      show_rmp_config: false,
      show_occ: this.getLocalStorageState('show_occ', true),
      show_cube: this.getLocalStorageState('show_cube', true),
      show_solid: this.getLocalStorageState('show_solid', true),
      show_single_dashed: this.getLocalStorageState('show_single_dashed', true),
      show_double_dashed: this.getLocalStorageState('show_double_dashed', true),
      show_crosswalk: this.getLocalStorageState('show_crosswalk', true),
      show_stopLine: this.getLocalStorageState('show_stopLine', true),
      show_lane: this.getLocalStorageState('show_lane', true),
      show_drivable_area: this.getLocalStorageState('show_drivable_area', true),
      global_weather: 0,
      global_time: 0,
      global_region: 0,
      lightInfoList: [], // PNC看灯结果列表
      perceptionLightInfoList: [], // 感知看灯结果列表
      showImageOcc: true,
    };
    this._wsRef = null;
  }

  getLocalStorageState(key, defaultValue) {
    try {
      const value = localStorage.getItem(`threeMonitor_${key}`);
      return value !== null ? value === 'true' : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  setLocalStorageState(key, value) {
    try {
      localStorage.setItem(`threeMonitor_${key}`, String(value));
    } catch (e) {
      console.error('Failed to save to localStorage:', e);
    }
  }

  componentDidMount() {
    this._mountTimer = setInterval(() => {
      const node = document.getElementById(
        this.props.elementId || 'WebGL-output'
      );
      if (node) {
        clearInterval(this._mountTimer);
        this._mountTimer = null;
        this.initThree();
        this.animation();
        this.initListener();
      }
    }, 100);
  }

  componentWillUnmount() {
    this._isUnmounted = true;
    if (this._mountTimer) {
      clearInterval(this._mountTimer);
      this._mountTimer = null;
    }
    if (this._animFrame != null) {
      cancelAnimationFrame(this._animFrame);
      this._animFrame = null;
    }
    if (this._keyDownHandler) {
      document.removeEventListener('keydown', this._keyDownHandler);
      this._keyDownHandler = null;
    }
    try {
      this._wsRef.current.close();
      this._wsRef = null;
    } catch (e) { }
  }

  initListener() {
    this._keyDownHandler = (event) => {
      if (event.key === 'o' || event.key === 'O') {
        this.setState({ showImageOcc: !this.state.showImageOcc });
      }
    };
    document.addEventListener('keydown', this._keyDownHandler);
  }

  update() {
    this.controls.update();
  }

  animation = () => {
    if (this._isUnmounted) return;
    // 根据时间进行函数的调用
    this._animFrame = requestAnimationFrame(this.animation);
    let interval = 1000 / this.fps; // 一秒时间/刷新帧率更新数据毫秒数
    this.now = Date.now();
    let delta = this.now - this.then;
    if (delta > interval) {
      this.then = this.now - (delta % interval);
      if (this.props.renderOnDemand) {
        // 按需渲染（仅回放页启用）：仅在有新数据/相机变化/外部标记脏时渲染，
        // 空闲（暂停无数据）时不占用主线程，避免拖慢同屏视频播放
        this.renderOnDemandTick();
      } else {
        // 默认路径：其他消费者（实时页等）保持原有逐帧渲染行为
        this.DoProcessLocalView();
        this.controls.update();
        this.renderer.render(this.scene, this.camera);
        this.notifyFirstFrameIfNeeded();
      }
    }
  };

  // 按需渲染的一拍：有新数据帧、相机 change、外部 setSize 尺寸漂移时才真正 render
  renderOnDemandTick() {
    const drewNewFrame = this.DoProcessLocalView();
    this.controls.update();
    // 外部（如单车监控页）可能直接调用 renderer.setSize 自适应窗口，
    // 检测画布尺寸漂移并补一次渲染，避免尺寸变化后画面停在不一致状态
    if (!this._needsRender && this.renderer && this.container) {
      if (!this._sizeVec) this._sizeVec = new THREE.Vector2();
      this.renderer.getSize(this._sizeVec);
      if (
        this._sizeVec.x !== this.container.clientWidth ||
        this._sizeVec.y !== this.container.clientHeight
      ) {
        this._needsRender = true;
      }
    }
    if (drewNewFrame || this._needsRender) {
      this._needsRender = false;
      this.renderer.render(this.scene, this.camera);
      this.notifyFirstFrameIfNeeded();
    }
  }

  // 首帧渲染完成回调：在“至少收到并处理过一帧数据”后，等一次 render 后触发
  notifyFirstFrameIfNeeded() {
    if (this.__firstFramePending && !this.__firstFrameNotified) {
      this.__firstFramePending = false;
      this.__firstFrameNotified = true;
      if (typeof this.props.onFirstFrameRendered === 'function') {
        try {
          this.props.onFirstFrameRendered();
        } catch (e) {}
      }
    }
  }

  initThree() {
    //初始化threeJs的环境
    const _this = this;
    let camera_ = this.camera;
    let scene_ = this.scene;
    scene_ = new THREE.Scene();
    let renderer = this.renderer;
    let group;
    this.container = document.getElementById(
      this.props.elementId || 'WebGL-output'
    );
    let width = this.container?.clientWidth ?? window.innerWidth,
      height = this.container?.clientHeight ?? window.innerHeight - 60;
    group = new THREE.Group();
    scene_.add(group);
    scene_.add(_this.group_noise_point);
    scene_.add(_this.groupParkingNode);
    scene_.add(_this.group_occ_grids);
    scene_.add(_this.group_bev_seg);

    camera_ = new THREE.PerspectiveCamera(60, width / height, 1, 2000);
    camera_.position.x = this.current_x;
    camera_.position.y = this.current_y;
    camera_.position.z = 50;
    camera_.lookAt(new THREE.Vector3(this.current_x, this.current_y, 0));
    this.controls = new TrackballControls(camera_, this.container);
    this.controls.minDistance = 10;
    this.controls.maxDistance = 1000;
    // 按需渲染模式下：相机被用户拖动/缩放时派发 change，标记需要重渲染
    if (this.props.renderOnDemand) {
      this.controls.addEventListener('change', () => {
        this._needsRender = true;
      });
    }
    let amBi = new THREE.AmbientLight(0xffffff); //光源
    scene_.add(amBi);
    this.spotLight = new THREE.DirectionalLight(0xffffff);
    this.spotLight.position.set(550, 100, 50);
    this.spotLight.intensity = 0.8;
    scene_.add(this.spotLight);
    const loader = new GLTFLoader().setPath('/models/');
    loader.load('car01.gltf', (gltf) => {
      gltf.scene.traverse((child) => { });
      let car_mesh = gltf.scene;
      car_mesh.scale.set(0.01, 0.01, 0.01);
      car_mesh.position.set(0, 0, 0);
      scene_.add(car_mesh);
      this.app.car_mesh = car_mesh;
      this._needsRender = true;
    });
    renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
    });
    renderer.setClearColor(0x050505);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    this.container.appendChild(renderer.domElement);
    this.camera = camera_;
    this.scene = scene_;
    this.renderer = renderer;
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x999999, linewidth: 1 })
    ); //misc
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x2374de, linewidth: 1 })
    ); //car
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xd56f79, linewidth: 1 })
    ); //pedestrain
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xedb936, linewidth: 1 })
    ); //cyclist
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x5b9546, linewidth: 1 })
    ); //truck
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xaa6543, linewidth: 1 })
    ); //bus
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x999999, linewidth: 1 })
    ); //pointcloud
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x999999, linewidth: 1 })
    ); //artifical_obstacle
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xee9818, linewidth: 1 })
    ); //TRAFFIC_CONE
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x18e3ee, linewidth: 1 })
    ); //LOW_PROFILE_OBSTACLE
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xee18d3, linewidth: 1 })
    ); //ROAD_SEWER
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xffffff00, linewidth: 1 })
    ); //STATIC_NON_MOTOR
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xffffff00, linewidth: 1 })
    ); //WATER_BARRIER
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xab91e0, linewidth: 1 })
    ); //TRICYCLE
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xedb936, linewidth: 1 })
    ); //CYCLIST_STOPPED
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xff0000, linewidth: 1 })
    ); //POLE
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0x3dae58, linewidth: 1 })
    ); //JD_VEHICLE
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xd4237a, linewidth: 1 })
    ); //CYCLIST_STOPPED
    this.material_cubes.push(
      new THREE.LineBasicMaterial({ color: 0xf7a83f, linewidth: 1 })
    ); //IMAGE_OCC

    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x999999,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x2374de,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xd56f79,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xedb936,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x5b9546,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xaa6543,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x999999,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x999999,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xee9818,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x18e3ee,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xee18d3,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xffffff00,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xffffff00,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xab91e0,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xedb936,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xff0000,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0x3dae58,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xd4237a,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );
    this.material_cubes_mesh.push(
      new THREE.MeshLambertMaterial({
        color: 0xf7a83f,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
    );

    this.texture_cube.push(new THREE.TextureLoader().load(MISC));
    this.texture_cube.push(new THREE.TextureLoader().load(CAR));
    this.texture_cube.push(new THREE.TextureLoader().load(PEDESTRIAN));
    this.texture_cube.push(new THREE.TextureLoader().load(CYCLIST));
    this.texture_cube.push(new THREE.TextureLoader().load(TRUCK));
    this.texture_cube.push(new THREE.TextureLoader().load(BUS));
    this.texture_cube.push(new THREE.TextureLoader().load(MISC)); //pointcloud
    this.texture_cube.push(new THREE.TextureLoader().load(MISC)); //Artificial
    this.texture_cube.push(new THREE.TextureLoader().load(TRAFFIC_CONE)); //Cone
    this.texture_cube.push(new THREE.TextureLoader().load(MISC)); //LowProfile
    this.texture_cube.push(new THREE.TextureLoader().load(ROAD_SEWER)); //RoadSewer
    this.texture_cube.push(new THREE.TextureLoader().load(NONE)); //RoadSewer
    this.texture_cube.push(new THREE.TextureLoader().load(NONE)); //RoadSewer
    this.texture_cube.push(new THREE.TextureLoader().load(TRICYCLE)); //TRICYCLE
    this.texture_cube.push(new THREE.TextureLoader().load(CYCLIST)); //CYCLIST_STOPPED
    this.texture_cube.push(new THREE.TextureLoader().load(POLE)); //POLE
    this.texture_cube.push(new THREE.TextureLoader().load(JD_VEHICLE)); //JD_VEHICLE
    this.texture_cube.push(new THREE.TextureLoader().load(OTHER_VEHICLE)); //OTHER_VEHICLE
    this.texture_cube.push(new THREE.TextureLoader().load(BRAKE));
    this.texture_cube.push(new THREE.TextureLoader().load(null));
    this.texture_cube.push(new THREE.TextureLoader().load(null));
    
    // 感知红绿灯图标纹理
    this.trafficLightTexture = new THREE.TextureLoader().load(TRAFFIC_LIGHT);

    let icon_size = 32;

    for (let i = 0; i < this.texture_cube.length; i++) {
      let isStopLight = i == 18;
      this.material_icon_cube.push(
        new THREE.PointsMaterial({
          size: isStopLight ? icon_size / 1.5 : icon_size,
          sizeAttenuation: false,
          map: this.texture_cube[i],
          alphaTest: 0.5,
          transparent: true,
        })
      );
    }

    this.map_material_lidar_point.set(
      'FRAME_LIDAR_TOP',
      new THREE.MeshLambertMaterial({
        color: 0xbdbd6b,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_FRONT',
      new THREE.MeshLambertMaterial({
        color: 0x0000ff,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_REAR',
      new THREE.MeshLambertMaterial({
        color: 0xee0000,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_LEFT',
      new THREE.MeshLambertMaterial({
        color: 0xffffff,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_RIGHT',
      new THREE.MeshLambertMaterial({
        color: 0x00ff00,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_FRONT_LEFT',
      new THREE.MeshLambertMaterial({
        color: 0x15d5e0,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.map_material_lidar_point.set(
      'FRAME_LIDAR_FRONT_RIGHT',
      new THREE.MeshLambertMaterial({
        color: 0x9915e0,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      })
    );
    this.lidar_names = [
      'FRAME_LIDAR_TOP',
      'FRAME_LIDAR_FRONT',
      'FRAME_LIDAR_REAR',
      'FRAME_LIDAR_LEFT',
      'FRAME_LIDAR_RIGHT',
      'FRAME_LIDAR_FRONT_LEFT',
      'FRAME_LIDAR_FRONT_RIGHT',
    ];

    this.material_boundary_dot_other = new THREE.LineDashedMaterial({
      color: 0x333333,
      linewidth: 1,
      scale: 1,
      dashSize: 0.5,
      gapSize: 0.5,
    });
    this.material_planning = new THREE.MeshBasicMaterial({
      color: 0x46eac5,
      side: THREE.DoubleSide,
      polygonOffsetFactor: 1.0,
      polygonOffsetUnits: 10.0,
    });
    this.material_trajectory = new THREE.MeshBasicMaterial({
      color: 0x16c79f,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.3,
      polygonOffsetFactor: -1.0,
      polygonOffsetUnits: 10.0,
    });
    this.material_trajectory_line = new THREE.LineBasicMaterial({
      color: 0x16c79f,
      linewidth: 1,
    });
    this.material_routing_info = new THREE.LineBasicMaterial({
      color: 0xff0000,
      linewidth: 2,
    });
    this.material_prediction_trajectory = new THREE.MeshBasicMaterial({
      color: 0xffff00,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.66,
      polygonOffsetFactor: -1.0,
      polygonOffsetUnits: 10.0,
    });
    this.material_boundary_dash_white = new THREE.LineDashedMaterial({
      color: 0xc9c9c9,
      linewidth: 1,
      scale: 1,
      dashSize: 1,
      gapSize: 2,
    });
    this.materialParkingBoundBox = new THREE.LineBasicMaterial({
      color: 0x16c79f,
      linewidth: 1,
    });

    // Gate材质初始化 - 穿透显示配置
    this.material_gate_auto = new THREE.LineBasicMaterial({
      color: 0x0000ff, // 蓝色 - 自动门
      linewidth: 5,
      depthTest: false, // 禁用深度测试,实现穿透显示
      depthWrite: false, // 禁用深度写入,避免遮挡其他对象
      transparent: true, // 启用透明
    });
    this.material_gate_manual = new THREE.LineBasicMaterial({
      color: 0x0000ff, // 蓝色 - 手动门
      linewidth: 5,
      depthTest: false,
      depthWrite: false,
      transparent: true,
    });
    this.material_gate_barrier = new THREE.LineBasicMaterial({
      color: 0x800080, // 紫色 - 道闸门
      linewidth: 5,
      depthTest: false,
      depthWrite: false,
      transparent: true,
    });
    this.material_gate_unknown = new THREE.LineBasicMaterial({
      color: 0xffff00, // 黄色 - 未知类型
      linewidth: 5,
      depthTest: false,
      depthWrite: false,
      transparent: true,
    });

    this.InitBufferGeometry();
  }

  InitBufferGeometry() {
    for (let i = 0; i < 8; i++) {
      this.AllocateLabelBuffer(
        i,
        this.cube_label_map,
        this.material_icon_cube[i],
        5
      );
    }
    this.AllocatePolyCubeBuffer(
      6,
      this.convex_buffer_map,
      new THREE.MeshLambertMaterial({
        color: 0x2374de,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      }),
      10
    );
    this.AllocateLineBuffer(
      this.GeometryType.LINE_SEGMENT,
      24,
      this.cube_pillar_map,
      this.material_lane,
      50
    );
    this.AllocateLineBuffer(
      this.GeometryType.LINE_STRIP,
      10,
      this.cube_trajectory_map,
      this.material_prediction_trajectory,
      20
    );
    this.AllocateLineBuffer(
      this.GeometryType.LINE_LOOP,
      4,
      this.trajectory_buffer,
      this.material_lane
    );
    this.AllocateLineBuffer(
      this.GeometryType.LINE_LOOP,
      4,
      this.planning_path_buffer,
      this.material_planning
    );
    this.AllocatePolygonBuffer(
      4,
      this.trajectory_polygon_buffer,
      this.material_trajectory
    );
    this.AllocatePolygonBuffer(
      4,
      this.planning_path_polygon_buffer,
      this.material_planning
    );
    this.AllocateLineBuffer(
      this.GeometryType.LINE_STRIP,
      350,
      this.routing_buffer,
      this.material_routing_info
    );
    this.CreateRoutingBuffer();
    this.CreateHDMapDrawable();
    this.CreateNoiseMeshBuffer(1);
    this.CreateParkingNodeBuffer(1);
    this.ensureOccGridImagePlane();
    this.ensureBevSegImagePlane();
  }

  CreateParkingNodeBuffer(count) {
    for (let i = 0; i < count; i++) {
      //create arrow
      var dir = new THREE.Vector3(10, 0, 0);
      dir.normalize();
      var origin = new THREE.Vector3(0, 0, 0);
      var length = 3;
      var hex = 0xff0000;
      var headLength = 0.5;
      var headWidth = 0.5;
      let arrow = new THREE.ArrowHelper(
        dir,
        origin,
        length,
        hex,
        headLength,
        headWidth
      );
      arrow.visible = false;
      this.groupParkingNode.add(arrow);

      //create rectangle
      var geometry = new THREE.Geometry();
      geometry.vertices.push(
        new THREE.Vector3(1.5, 0.5, 0.2),
        new THREE.Vector3(1.5, -0.5, 0.2),
        new THREE.Vector3(-0.5, -0.5, 0.2),
        new THREE.Vector3(-0.5, 0.5, 0.2)
      );
      let bound = new THREE.LineLoop(geometry, this.materialParkingBoundBox);
      bound.visible = false;
      this.groupParkingNode.add(bound);

      this.parkingNodes.push({ arrow, bound });
    }
  }


  ensureOccGridImagePlane(cols, rows) {
    const {
      x_size,
      y_size,
      x_num: defaultCols,
      y_num: defaultRows,
    } = this.occ_grid_config;
    const planeCols = cols || defaultCols;
    const planeRows = rows || defaultRows;

    if (!this.occ_grid_plane_material) {
      this.occ_grid_plane_material = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        transparent: true,
        alphaTest: 0.01,
        depthWrite: false,
        depthTest: false, // 禁用深度测试,实现穿透显示
      });
    }

    const needRecreate =
      !this.occ_grid_plane_mesh ||
      this.occ_grid_plane_cols !== planeCols ||
      this.occ_grid_plane_rows !== planeRows;

    if (needRecreate) {
      if (this.occ_grid_plane_mesh) {
        this.group_occ_grids.remove(this.occ_grid_plane_mesh);
        this.occ_grid_plane_mesh.geometry.dispose();
      }
      const geometry = new THREE.PlaneGeometry(
        x_size * planeCols,
        y_size * planeRows
      );
      this.occ_grid_plane_mesh = new THREE.Mesh(
        geometry,
        this.occ_grid_plane_material
      );
      this.occ_grid_plane_mesh.position.z = 0.1;
      this.occ_grid_plane_mesh.visible = false;
      this.group_occ_grids.add(this.occ_grid_plane_mesh);
      this.occ_grid_plane_cols = planeCols;
      this.occ_grid_plane_rows = planeRows;
    }
  }

  ensureBevSegImagePlane(cols, rows) {
    const {
      x_size,
      y_size,
      x_num: defaultCols,
      y_num: defaultRows,
    } = this.bev_seg_config;
    const planeCols = cols || defaultCols;
    const planeRows = rows || defaultRows;

    if (!this.bev_seg_plane_material) {
      this.bev_seg_plane_material = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        transparent: true,
        alphaTest: 0.01,
        depthWrite: false,
      });
    }

    const needRecreate =
      !this.bev_seg_plane_mesh ||
      this.bev_seg_plane_cols !== planeCols ||
      this.bev_seg_plane_rows !== planeRows;

    if (needRecreate) {
      if (this.bev_seg_plane_mesh) {
        this.group_bev_seg.remove(this.bev_seg_plane_mesh);
        this.bev_seg_plane_mesh.geometry.dispose();
      }
      const geometry = new THREE.PlaneGeometry(
        x_size * planeCols,
        y_size * planeRows
      );
      this.bev_seg_plane_mesh = new THREE.Mesh(
        geometry,
        this.bev_seg_plane_material
      );
      this.bev_seg_plane_mesh.position.z = 0.09; // 略低于occ grid
      this.bev_seg_plane_mesh.visible = false;
      this.group_bev_seg.add(this.bev_seg_plane_mesh);
      this.bev_seg_plane_cols = planeCols;
      this.bev_seg_plane_rows = planeRows;
    }
  }

  convertOccGridDataToBytes(data) {
    if (!data) return null;
    if (data instanceof Uint8Array) return data;
    if (Array.isArray(data)) return new Uint8Array(data);

    if (typeof data === 'string') {
      const base64 = data.includes(',') ? data.split(',')[1] : data;
      try {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
      } catch (e) {
        return null;
      }
    }

    if (data.buffer instanceof ArrayBuffer) {
      return new Uint8Array(data.buffer);
    }

    return null;
  }

  /**
   * CSR字节流解码为二维掩膜数组 (Uint8Array, rows * cols)
   * CSR layout (little-endian):
   *   offset 0: uint32 magic = 0x52534301 ('CSR\x01')
   *   offset 4: uint16 rows
   *   offset 6: uint16 cols
   *   offset 8: uint32 nnz
   *   offset 12: int32 row_ptr[rows+1]
   *   offset 12+4*(rows+1): int32 col_idx[nnz]
   */
  decodeCsrToMask(csrBytes, rows, cols, setValue) {
    if (!csrBytes || csrBytes.length < 12) return null;
    const view = new DataView(csrBytes.buffer, csrBytes.byteOffset, csrBytes.byteLength);

    const magic = view.getUint32(0, true);
    if (magic !== 0x52534301) {
      console.error('CSR magic mismatch:', magic);
      return null;
    }

    const csrRows = view.getUint16(4, true);
    const csrCols = view.getUint16(6, true);
    const nnz = view.getUint32(8, true);

    const useRows = csrRows > 0 ? csrRows : rows;
    const useCols = csrCols > 0 ? csrCols : cols;

    const mask = new Uint8Array(useRows * useCols).fill(0);
    const rowPtrOffset = 12;
    const colIdxOffset = rowPtrOffset + 4 * (useRows + 1);

    for (let r = 0; r < useRows; r++) {
      const rowStart = view.getInt32(rowPtrOffset + 4 * r, true);
      const rowEnd = view.getInt32(rowPtrOffset + 4 * (r + 1), true);
      for (let k = rowStart; k < rowEnd; k++) {
        const c = view.getInt32(colIdxOffset + 4 * k, true);
        if (r < useRows && c < useCols) {
          mask[r * useCols + c] = setValue;
        }
      }
    }

    return { mask, rows: useRows, cols: useCols };
  }

  /**
   * Dense Zstd字节流解码为二维数组 (Uint8Array, rows * cols)
   * Dense layout (little-endian):
   *   offset 0: uint32 magic = 0x44454E01 ('DEN\x01')
   *   offset 4: uint16 rows
   *   offset 6: uint16 cols
   *   offset 8: uint32 payload_size
   *   offset 12: zstd-compressed row-major u8 pixel stream
   */
  decodeDenseZstdToMask(denseBytes, rows, cols) {
    if (!denseBytes || denseBytes.length < 12) return null;
    const view = new DataView(denseBytes.buffer, denseBytes.byteOffset, denseBytes.byteLength);

    const magic = view.getUint32(0, true);
    if (magic !== 0x44454E01) {
      console.error('Dense magic mismatch:', magic);
      return null;
    }

    const denseRows = view.getUint16(4, true);
    const denseCols = view.getUint16(6, true);
    const payloadSize = view.getUint32(8, true);

    const useRows = denseRows > 0 ? denseRows : rows;
    const useCols = denseCols > 0 ? denseCols : cols;

    const compressedPayload = denseBytes.subarray(12, 12 + payloadSize);
    const decompressed = zstdDecompress(compressedPayload);

    if (decompressed.length !== useRows * useCols) {
      console.error('Dense decompressed size mismatch:', decompressed.length, 'expected:', useRows * useCols);
      // 仍尝试使用，截断或填充
    }

    const mask = new Uint8Array(useRows * useCols).fill(0);
    const copyLen = Math.min(decompressed.length, mask.length);
    for (let i = 0; i < copyLen; i++) {
      mask[i] = decompressed[i];
    }

    return { mask, rows: useRows, cols: useCols };
  }

  /**
   * 将OccGridsPacked的perType CSR数据解码为RGBA纹理
   * OccGridsPacked结构: { header, sensingHeader, grids: { width, height, perType: [{type, csrData}] } }
   * 每个perType项包含一个CSR编码的稀疏bool掩膜
   */
  decodeOccGridsCsrToRgba(grids, cols, rows) {
    if (!grids || !grids.perType || grids.perType.length === 0) {
      return null;
    }

    const gridWidth = grids.width > 0 ? grids.width : cols;
    const gridHeight = grids.height > 0 ? grids.height : rows;
    const rgba = new Uint8Array(gridWidth * gridHeight * 4).fill(0);

    // OCC color: 橙黄色 0xf7a83f, alpha 180
    for (const entry of grids.perType) {
      const csrBytes = this.convertOccGridDataToBytes(entry.csrData);
      if (!csrBytes || csrBytes.length === 0) continue;

      const result = this.decodeCsrToMask(csrBytes, gridHeight, gridWidth, 1);
      if (!result) continue;

      const { mask } = result;
      for (let row = 0; row < result.rows; row++) {
        for (let col = 0; col < result.cols; col++) {
          if (mask[row * result.cols + col] > 0) {
            const dst = ((gridHeight - 1 - row) * gridWidth + col) * 4;
            rgba[dst] = 0xf7;
            rgba[dst + 1] = 0xa8;
            rgba[dst + 2] = 0x3f;
            rgba[dst + 3] = 180;
          }
        }
      }
    }

    return { rgba, cols: gridWidth, rows: gridHeight };
  }

  /**
   * 将RmpUnpacked_BevSegmentation的packedChannel数据解码为RGBA纹理
   * packedChannel[0]包含ZSTD_DENSE编码的bitpacked数据
   * Dense layout (little-endian):
   *   offset 0: uint32 magic = 0x44454E01 ('DEN\x01')
   *   offset 4: uint16 rows
   *   offset 6: uint16 cols
   *   offset 8: uint32 payload_size
   *   offset 12: zstd-compressed row-major u8 pixel stream
   * 
   * bitpacked数据：每个字节包含8个通道的bit信息
   * bit 0 = CURB, bit 1 = DASHED, bit 2 = SOLID, bit 3 = DOUBLE_SOLID,
   * bit 4 = crosswalk, bit 5 = stopLine, bit 6 = lane, bit 7 = drivable_area
   */
  decodeBevSegPackedToRgba(bevSegResult, cols, rows) {
    // 从packedChannel[0]获取bitpacked数据
    const packedChannels = bevSegResult.packedChannel;
    if (!packedChannels || packedChannels.length === 0 || !packedChannels[0].data) {
      const fallbackWidth = bevSegResult.width > 0 ? bevSegResult.width : cols;
      const fallbackHeight = bevSegResult.height > 0 ? bevSegResult.height : rows;
      return { rgba: new Uint8Array(fallbackWidth * fallbackHeight * 4).fill(0), cols: fallbackWidth, rows: fallbackHeight };
    }

    const segWidth = bevSegResult.width > 0 ? bevSegResult.width : cols;
    const segHeight = bevSegResult.height > 0 ? bevSegResult.height : rows;
    const totalPixels = segWidth * segHeight;

    const rawBytes = this.convertOccGridDataToBytes(packedChannels[0].data);
    if (!rawBytes || rawBytes.length === 0) {
      return { rgba: new Uint8Array(totalPixels * 4).fill(0), cols: segWidth, rows: segHeight };
    }

    // Step 1: 解压 Dense Zstd 格式数据
    const denseResult = this.decodeDenseZstdToMask(rawBytes, segHeight, segWidth);
    if (!denseResult || !denseResult.mask) {
      console.error('Failed to decode Dense Zstd for BEV segmentation');
      return { rgba: new Uint8Array(totalPixels * 4).fill(0), cols: segWidth, rows: segHeight };
    }

    const { mask: bitpackedData } = denseResult;
    // Step 2: bitpacked数据解码：每个字节包含8个通道的bit信息
    const rgba = new Uint8Array(totalPixels * 4);

    // 获取8个通道的渲染状态
    const channelStates = [
      this.state.show_cube,           // bit 0
      this.state.show_solid,          // bit 1
      this.state.show_single_dashed,  // bit 2
      this.state.show_double_dashed,  // bit 3
      this.state.show_crosswalk,      // bit 4
      this.state.show_stopLine,       // bit 5
      this.state.show_lane,           // bit 6
      this.state.show_drivable_area   // bit 7
    ];

    for (let i = 0; i < totalPixels; i++) {
      const byteVal = bitpackedData[i];
      if (byteVal === 0) continue; // 无任何通道命中

      let selectedColor = null;
      let selectedOpacity = 0;

      // 优先使用下标小的已配置颜色（bit 0优先），但需检查该通道是否启用
      for (let bit = 0; bit < 8; bit++) {
        if ((byteVal & (1 << bit)) && bit < this.bev_seg_color_config.length) {
          // 检查该通道是否启用渲染
          if (!channelStates[bit]) {
            continue; // 该通道未启用，跳过
          }
          const [color, opacity] = this.bev_seg_color_config[bit];
          selectedColor = color;
          selectedOpacity = opacity;
          break;
        }
      }

      const dst = i * 4;
      if (selectedColor) {
        rgba[dst] = selectedColor[0];
        rgba[dst + 1] = selectedColor[1];
        rgba[dst + 2] = selectedColor[2];
        rgba[dst + 3] = Math.floor(selectedOpacity * 255);
      }
    }

    return { rgba, cols: segWidth, rows: segHeight };
  }

  updateOccGridTextureSync(occGridsPacked, signature) {
    try {
      const {
        x_num: defaultCols,
        y_num: defaultRows,
      } = this.occ_grid_config;
      const grids = occGridsPacked.grids;
      if (!grids) {
        if (this.occ_grid_plane_mesh) this.occ_grid_plane_mesh.visible = false;
        return;
      }

      const result = this.decodeOccGridsCsrToRgba(grids, defaultCols, defaultRows);
      if (!result || !result.rgba) {
        if (this.occ_grid_plane_mesh) this.occ_grid_plane_mesh.visible = false;
        return;
      }

      const { rgba, cols, rows } = result;

      // 确保plane尺寸与数据匹配
      this.ensureOccGridImagePlane(cols, rows);

      const texture = new THREE.DataTexture(rgba, cols, rows, THREE.RGBAFormat);
      texture.flipY = true;
      texture.needsUpdate = true;
      texture.minFilter = THREE.NearestFilter;
      texture.magFilter = THREE.NearestFilter;
      texture.generateMipmaps = false;

      if (this.occ_grid_texture) this.occ_grid_texture.dispose();
      this.occ_grid_texture = texture;
      this.occ_grid_plane_material.map = texture;
      this.occ_grid_plane_material.needsUpdate = true;
      this.occ_grid_plane_mesh.visible = true;
      this.occ_grid_last_signature = signature;
    } catch (e) {
      console.error('updateOccGridTextureSync error:', e);
      if (this.occ_grid_plane_mesh) this.occ_grid_plane_mesh.visible = false;
    } finally {
      this.occ_grid_pending_signature = null;
    }
  }

  updateBevSegTextureSync(bevSegResult, signature) {
    try {
      const {
        x_num: defaultCols,
        y_num: defaultRows,
      } = this.bev_seg_config;

      const result = this.decodeBevSegPackedToRgba(bevSegResult, defaultCols, defaultRows);
      if (!result || !result.rgba) {
        if (this.bev_seg_plane_mesh) this.bev_seg_plane_mesh.visible = false;
        return;
      }

      const { rgba, cols, rows } = result;

      // 确保plane尺寸与数据匹配
      this.ensureBevSegImagePlane(cols, rows);

      const texture = new THREE.DataTexture(rgba, cols, rows, THREE.RGBAFormat);
      texture.flipY = true;
      texture.needsUpdate = true;
      texture.minFilter = THREE.NearestFilter;
      texture.magFilter = THREE.NearestFilter;
      texture.generateMipmaps = false;

      if (this.bev_seg_texture) this.bev_seg_texture.dispose();
      this.bev_seg_texture = texture;
      this.bev_seg_plane_material.map = texture;
      this.bev_seg_plane_material.needsUpdate = true;
      this.bev_seg_plane_mesh.visible = true;
      this.bev_seg_last_signature = signature;
    } catch (e) {
      console.error('updateBevSegTextureSync error:', e);
      if (this.bev_seg_plane_mesh) this.bev_seg_plane_mesh.visible = false;
    } finally {
      this.bev_seg_pending_signature = null;
    }
  }

  drawOccGridsImage(occGridsPacked) {
    const {
      x_min,
      y_min,
      x_size,
      y_size,
      x_num: defaultCols,
      y_num: defaultRows,
      align_to_vehicle_center,
      align_to_vehicle_heading,
    } = this.occ_grid_config;

    if (!this.state.showImageOcc || !this.state.show_occ || !occGridsPacked || !occGridsPacked.grids) {
      if (this.occ_grid_plane_mesh) this.occ_grid_plane_mesh.visible = false;
      return;
    }

    const grids = occGridsPacked.grids;
    const cols = grids.width > 0 ? grids.width : defaultCols;
    const rows = grids.height > 0 ? grids.height : defaultRows;

    if (!grids.perType || grids.perType.length === 0) {
      if (this.occ_grid_plane_mesh) this.occ_grid_plane_mesh.visible = false;
      return;
    }

    this.ensureOccGridImagePlane(cols, rows);

    const yawForOcc = align_to_vehicle_heading ? this.current_yaw : 0;
    let planeCenterX = this.current_x;
    let planeCenterY = this.current_y;

    if (!align_to_vehicle_center) {
      const localCenterX = x_min + (((cols - 1) * x_size) / 2);
      const localCenterY = y_min + ((rows - 1) * y_size) / 2;
      const centerOffset = this.rotatePoint(localCenterX, localCenterY, yawForOcc);
      planeCenterX += centerOffset.x;
      planeCenterY += centerOffset.y;
    }

    // 使用新的lidar_master_to_base_link_trans字段调整雷达坐标偏移量
    const [lidarX, lidarY] = this.lidar_master_to_base_link_trans;
    const radarOffset = this.rotatePoint(lidarX, lidarY, this.current_yaw);
    planeCenterX += radarOffset.x;
    planeCenterY += radarOffset.y;

    this.occ_grid_plane_mesh.position.set(planeCenterX, planeCenterY, 0.1);
    this.occ_grid_plane_mesh.rotation.z = yawForOcc;

    // 生成签名：基于perType的数量和CSR数据大小
    let signature = `occ-${cols}-${rows}-${grids.perType.length}`;
    for (let i = 0; i < grids.perType.length; i++) {
      const csrBytes = this.convertOccGridDataToBytes(grids.perType[i].csrData);
      if (csrBytes && csrBytes.length > 0) {
        signature += `-${i}-${csrBytes.length}-${csrBytes[0]}-${csrBytes[csrBytes.length - 1]}`;
      }
    }

    if (signature === this.occ_grid_last_signature && this.occ_grid_texture) {
      this.occ_grid_plane_mesh.visible = true;
      return;
    }

    if (signature === this.occ_grid_pending_signature) {
      return;
    }

    this.occ_grid_pending_signature = signature;
    this.updateOccGridTextureSync(occGridsPacked, signature);
  }

  drawBevSegImage(bevSegResult) {
    const {
      x_min,
      y_min,
      x_size,
      y_size,
      x_num: defaultCols,
      y_num: defaultRows,
      align_to_vehicle_center,
      align_to_vehicle_heading,
    } = this.bev_seg_config;

    if (!this.state.showImageOcc || !bevSegResult) {
      if (this.bev_seg_plane_mesh) this.bev_seg_plane_mesh.visible = false;
      return;
    }

    // 新格式使用packedChannel[0]，获取width/height
    const packedChannels = bevSegResult.packedChannel;
    if (!packedChannels || packedChannels.length === 0 || !packedChannels[0].data) {
      if (this.bev_seg_plane_mesh) this.bev_seg_plane_mesh.visible = false;
      return;
    }

    const cols = bevSegResult.width > 0 ? bevSegResult.width : defaultCols;
    const rows = bevSegResult.height > 0 ? bevSegResult.height : defaultRows;

    this.ensureBevSegImagePlane(cols, rows);

    const yawForBev = align_to_vehicle_heading ? this.current_yaw : 0;
    let planeCenterX = this.current_x;
    let planeCenterY = this.current_y;

    if (!align_to_vehicle_center) {
      const localCenterX = x_min + (cols * x_size) / 2;
      const localCenterY = y_min + ((rows * y_size) / 2);
      const centerOffset = this.rotatePoint(localCenterX, localCenterY, yawForBev - Math.PI / 2);
      planeCenterX += centerOffset.x;
      planeCenterY += centerOffset.y;
    }

    // 使用新的lidar_master_to_base_link_trans字段调整雷达坐标偏移量
    const [lidarX, lidarY] = this.lidar_master_to_base_link_trans;
    const radarOffset = this.rotatePoint(lidarX, lidarY, this.current_yaw);
    planeCenterX += radarOffset.x;
    planeCenterY += radarOffset.y;

    this.bev_seg_plane_mesh.position.set(planeCenterX, planeCenterY, 0.1);
    this.bev_seg_plane_mesh.rotation.z = yawForBev - Math.PI / 2;

    // 创建签名用于缓存（基于packedChannel[0].data大小和渲染状态）
    const chData = this.convertOccGridDataToBytes(packedChannels[0].data);
    const channelStates = [
      this.state.show_cube,
      this.state.show_solid,
      this.state.show_single_dashed,
      this.state.show_double_dashed,
      this.state.show_crosswalk,
      this.state.show_stopLine,
      this.state.show_lane,
      this.state.show_drivable_area
    ].map(s => s ? '1' : '0').join('');
    const signature = `bevseg-${cols}-${rows}-${chData ? chData.length : 0}-${chData ? chData[0] : 0}-${chData ? chData[chData.length - 1] : 0}-${channelStates}`;

    if (signature === this.bev_seg_last_signature && this.bev_seg_texture) {
      this.bev_seg_plane_mesh.visible = true;
      return;
    }

    if (signature === this.bev_seg_pending_signature) {
      return;
    }

    this.bev_seg_pending_signature = signature;
    this.updateBevSegTextureSync(bevSegResult, signature);
  }

  CreateNoiseMeshBuffer(count) {
    for (let i = 0; i < count; i++) {
      let material = new THREE.MeshBasicMaterial({
        color: 0xff0000,
        wireframe: false,
      });
      let mesh = new THREE.Mesh(
        new THREE.SphereGeometry(0.25, 32, 32),
        material
      );
      mesh.visible = false;
      this.group_noise_point.add(mesh);
      this.noise_point_mesh.push(mesh);
    }
  }

  CreateHDMapDrawable() {
    this.scene.add(this.group_lanes);
    this.scene.add(this.group_boundaries);
    this.scene.add(this.groupStopLine);
    this.scene.add(this.groupPerceptionTrafficLights);
    this.scene.add(this.group_gates);
  }

  UpdateNoisePoints(noisePointinfo_list) {
    if (noisePointinfo_list === undefined || noisePointinfo_list === null)
      return;

    for (let i = 0; i < this.noise_point_mesh.length; i++) {
      let mesh = this.noise_point_mesh[i];
      mesh.visible = false;
      mesh.material.visible = false;
    }
    if (noisePointinfo_list.length > 0) {
      if (noisePointinfo_list.length > this.noise_point_mesh.length) {
        let reallocate_size =
          noisePointinfo_list.length - this.noise_point_mesh.length;
        this.CreateNoiseMeshBuffer(reallocate_size);
      }

      for (let i = 0; i < noisePointinfo_list.length; i++) {
        let noisePointinfo = noisePointinfo_list[i];
        let point = noisePointinfo.point_3d;
        let lidar_name = noisePointinfo.sourceLidar;
        let mesh = this.noise_point_mesh[i];
        if (this.map_material_lidar_point.has(lidar_name)) {
          let material = this.map_material_lidar_point.get(lidar_name);
          mesh.material.copy(material);
        } else {
        }
        mesh.material.visible = true;
        mesh.visible = true;
        mesh.position.set(
          point.x + this.current_x,
          point.y + this.current_y,
          point.z
        );
      }
    }
  }

  updateParkingGoals(parkingGoals) {
    //hide parking node's arrow and bound line
    for (let i = 0; i < this.parkingNodes.length; i++) {
      let node = this.parkingNodes[i];
      node.arrow.visible = false;
      node.bound.visible = false;
    }

    if (parkingGoals && parkingGoals.length > 0) {
      if (parkingGoals.length > this.parkingNodes.length) {
        const reallocateSize = parkingGoals.length - this.parkingNodes.length;
        this.CreateParkingNodeBuffer(reallocateSize);
      }
      for (let i = 0; i < parkingGoals.length; i++) {
        const parkingGoal = parkingGoals[i];
        const goalMapCoord = new THREE.Vector3(
          parkingGoal.x + this.current_x,
          parkingGoal.y + this.current_y,
          parkingGoal.z
        );

        let node = this.parkingNodes[i];
        //update arrow pose
        let arrow = node.arrow;
        arrow.position.copy(goalMapCoord);
        arrow.quaternion.setFromEuler(
          new THREE.Euler(0, 0, parkingGoal.theta - Math.PI / 2)
        );
        arrow.visible = true;

        //update bound pose
        let bound = node.bound;
        bound.position.copy(goalMapCoord);
        bound.quaternion.setFromEuler(new THREE.Euler(0, 0, parkingGoal.theta));
        bound.visible = true;
      }
    }
  }

  UpdateRandomNoisePoints() {
    let count_random = Math.floor(Math.random() * 3 + 1);
    for (let i = 0; i < this.noise_point_mesh.length; i++) {
      let mesh = this.noise_point_mesh[i];
      mesh.visible = false;
      mesh.material.visible = false;
    }
    if (count_random > this.noise_point_mesh.length) {
      let reallocate_size = count_random - this.noise_point_mesh.length;
      this.CreateNoiseMeshBuffer(reallocate_size);
    }

    for (let i = 0; i < count_random && i < this.noise_point_mesh.length; i++) {
      let mesh = this.noise_point_mesh[i];
      mesh.visible = true;
      let x = Math.random() * 10 - 5;
      let y = Math.random() * 10 - 5;
      let lidar_name_id = Math.floor(Math.random() * 7);
      let lidar_name = this.lidar_names[lidar_name_id];
      let material = this.map_material_lidar_point.get(lidar_name);
      mesh.material.copy(material);
      mesh.material.visible = true;
      mesh.position.x = x + this.current_x;
      mesh.position.y = y + this.current_y;
    }
  }

  create_label(material) {
    let vertices = [];
    vertices.push(0, 0, 0.9);
    let geometry = new THREE.BufferGeometry();
    geometry.dynamic = true;
    geometry.setAttribute(
      'position',
      new THREE.Float32BufferAttribute(vertices, 3)
    );
    return new THREE.Points(geometry, material);
  }

  CreateRoutingBuffer() {
    this.group_label_start = new THREE.Group();
    this.group_label_start.position.x = 0;
    this.group_label_start.position.y = 0;
    this.group_label_start.position.z = 0;
    this.group_label_end = new THREE.Group();
    this.group_label_end.position.x = 0;
    this.group_label_end.position.y = 0;
    this.group_label_end.position.z = 0;
    this.group_routing_path = new THREE.Group();
    this.group_label_start.add(this.create_label(this.material_label_start));
    this.group_label_end.add(this.create_label(this.material_label_end));
    let geometry = new THREE.Geometry();
    for (let j = 0; j < 100; j++) {
      geometry.vertices.push(
        new THREE.Vector3(
          Math.floor(Math.random() * 10 - 5),
          Math.floor(Math.random() * 10 - 5),
          0
        )
      );
    }
    let line = new THREE.Line(geometry, this.material_routing_info);
    this.routing_line = {
      geometry: geometry,
      line: line,
      material: this.material_routing_info,
    };
    this.group_routing_path.add(line);
    this.scene.add(this.group_label_start);
    this.scene.add(this.group_label_end);
    this.scene.add(this.group_routing_path);
    this.material_label_start.visible = false;
    this.material_label_end.visible = false;
    this.material_routing_info.visible = false;
  }

  draw_location(x, y, z, roll, pitch, yaw) {
    //绘制位置信息（pos_x,pos_y,0,0,0,yaw）
    this.quaternion_vehicle.setFromEuler(new THREE.Euler(roll, pitch, yaw));
    if (this.car_mesh !== undefined) {
      let diff = this.rotatePoint(0.2, 0, yaw);
      let dx = diff.x;
      let dy = diff.y;
      this.car_mesh.position.x = x + dx;
      this.car_mesh.position.y = y + dy;
      this.car_mesh.setRotationFromQuaternion(this.quaternion_vehicle);
    }
    this.current_x = x;
    this.current_y = y;
    this.current_yaw = yaw;
    let pose_current = new THREE.Vector3(x, y, 0.0);
    this.pose_last = this.pose_last ? pose_current : this.pose_last;
  }

  DoProcessLocalView() {
    //不为空的情况下删除头部并绘制
    if (this.deque_dataview.length > 0) {
      let data_msg = this.deque_dataview.shift();
      let diff_secs = (data_msg.current_time - data_msg.time / 1000000) / 1000;
      let time_text =
        this.GetTimeString(data_msg.time) +
        (!this.props.hiddenDelay ? ' 延时:' + diff_secs.toFixed(3) + '秒' : '');
      // 按需渲染模式下时间文本降频更新（原每帧 setState 一次，10/s），降低无关渲染开销；
      // 默认路径保持原有实时刷新行为
      if (this.props.renderOnDemand) {
        const nowMs = Date.now();
        if (nowMs - this._lastTextUpdateAt >= 500) {
          this._lastTextUpdateAt = nowMs;
          this.setState({ text_current_frame_time: time_text });
        }
      } else {
        this.setState({ text_current_frame_time: time_text });
      }
      this.DrawDataView(data_msg.data_view);
      this.props.handleRecordDiffTime &&
        this.props.handleRecordDiffTime(parseFloat(diff_secs.toFixed(3)));
      return true;
    }
    return false;
  }

  clear_buffer_pool_map(buffer_pool_map) {
    buffer_pool_map.forEach(function (item, key) {
      let bufs = item.buffers;
      item.index = 0;
      for (let i = 0; i < bufs.length; i++) bufs[i].material.visible = false;
    });
  }

  GetTimeString(time_stamp) {
    var da = new Date(time_stamp / 1000000);
    var year = da.getFullYear() + '年';
    var month = da.getMonth() + 1 + '月';
    var date = da.getDate() + '日';
    var hour = da.getHours() + '时';
    var min = da.getMinutes() + '分';
    var sec = da.getSeconds() + '秒';
    return year + ' ' + month + ' ' + date + ' ' + hour + ' ' + min + ' ' + sec;
  }

  //接收每帧数据并调用相应函数（函数收发器）
  DrawDataView(localview) {
    
    let yaw = localview.car.orientation ? localview.car.orientation.z : 0;
    let pos_x = localview.origin.x;
    let pos_y = localview.origin.y;

    const poleIsClose = !!localview.poleIsClose;
    if (poleIsClose !== this.state.poleIsClose) {
      this.setState({ poleIsClose });
    }

    // 更新lidar_master_to_base_link_trans数据
    if (localview.car && localview.car.lidarMasterToBaseLinkTrans && localview.car.lidarMasterToBaseLinkTrans.length === 6) {
      this.lidar_master_to_base_link_trans = localview.car.lidarMasterToBaseLinkTrans;
    }

    this.draw_location(pos_x, pos_y, 0, 0, 0, yaw);
    this.updateControlTarget();
    this.clear_buffer_pool_map(this.trajectory_polygon_buffer);
    this.clear_buffer_pool_map(this.planning_path_polygon_buffer);
    this.clear_buffer_pool_map(this.routing_buffer);
    this.clear_buffer_pool_map(this.cube_pillar_map);
    this.clear_buffer_pool_map(this.cube_trajectory_map);
    this.clear_buffer_pool_map(this.convex_buffer_map);
    this.clear_buffer_pool_map(this.cube_label_map);

    if (localview.lane.length > 0) {
      //绿色的路
      this.draw_lane(localview.lane);
    }
    if (localview.boundary.length > 0) {
      this.draw_boundary(localview.boundary);
    }
    if (localview.stopLine.length > 0) {
      this.drawStopLine(localview.stopLine);
    }
    // 绘制门数据
    if (localview.gate && localview.gate.length > 0) {
      this.draw_gates(localview.gate);
    }
    // 绘制感知看灯结果的停止线和列表
    if (localview.perceptionTrafficLightDecision && localview.perceptionTrafficLightDecision.length > 0) {
      // 新版数据：perceptionTrafficLightDecision
      this.drawPerceptionTrafficLightStopLines(localview.perceptionTrafficLightDecision);
      this.drawPerceptionTrafficLightList(localview.perceptionTrafficLightDecision);
      
      // 新版：处理PNC看灯结果
      if (localview.planning && localview.planning.trafficLightInformation) {
        this.drawPncTrafficLightList(localview.planning.trafficLightInformation);
      } else {
        // 新版但无PNC数据，清空lightInfoList
        this.setState({ lightInfoList: [] });
      }
    } else if (localview.trafficLight && localview.trafficLight.length > 0) {
      // 旧版数据兼容：trafficLight
      this.drawOldTrafficLights(localview.trafficLight);
      // 旧版：处理lightInfoList（收起显示第1个，展开显示全部）
      if (localview.planning && localview.planning.interestedLight) {
        this.drawLightList(localview.trafficLight, localview.planning.interestedLight);
      } else {
        this.drawLightList(localview.trafficLight, null);
      }
      // 旧版清空新版数据
      this.setState({ perceptionLightInfoList: [] });
    } else {
      this.clearPerceptionTrafficLightStopLines();
      this.setState({ perceptionLightInfoList: [], lightInfoList: [] });
    }
    if (localview.car) {
      //车的偏移角度
      this.setState({
        steerAngle: localview.car.steerAngle.toFixed(3),
      });
      //档位
      for (let item in this.GearState) {
        if (this.GearState[item] === localview.car.gearPosition) {
          this.setState({
            carGearPosition: item,
          });
        }
      }
      //主车尺寸
      let polygon = localview.car.polygon;
      if (polygon.length > 3) {
        let distance1 = this.euclideanDistance(polygon[0], polygon[1]);
        let distance2 = this.euclideanDistance(polygon[1], polygon[2]);
        let width = Math.min(distance1, distance2);
        let length = Math.max(distance1, distance2);
        if (this.car_mesh && this.car_mesh.scale) {
          this.car_mesh.scale.set(length / 188, width / 93, 0.01);
        }
      }
      let primary_lidar = localview.car.primaryLidar;
      if (primary_lidar && !this.primaryLidarConfig) {
        this.primaryLidarConfig = primary_lidar
      }
    }
    if (localview.obstacle.length > 0) {
      //障碍物
      this.draw_buffer_obstacles(localview.obstacle);
    }
    if (localview.planning) {
      this.draw_planning_buffer(localview.planning);
    }
    if (localview.mcp) {
      this.updateViewMcp(localview.mcp);
    }
    if (localview.routing) this.draw_buffer_routing(localview.routing);

    this.UpdateNoisePoints(localview.noisePointInfo);

    // Draw OCC grids (new: occGridsPacked with CSR encoding)
    if (localview.occGridsPacked) {
      this.drawOccGridsImage(localview.occGridsPacked);
    }
    // Draw BEV segmentation result (new: realMapProcessUnpacked with CSR/Zstd encoding)
    if (localview.realMapProcessUnpacked && localview.realMapProcessUnpacked.bevSegResult) {
      this.drawBevSegImage(localview.realMapProcessUnpacked.bevSegResult);
    }
  }

  rotatePoint(x, y, heading) {
    const xNew = x * Math.cos(heading) - y * Math.sin(heading);
    const yNew = x * Math.sin(heading) + y * Math.cos(heading);
    return { x: xNew, y: yNew };
  }

  euclideanDistance(polygon1, polygon2) {
    let x1 = polygon1.x;
    let y1 = polygon1.y;
    let x2 = polygon2.x;
    let y2 = polygon2.y;
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  }

  // 绘制感知红绿灯：停止线+红绿灯图标+ID标签
  drawPerceptionTrafficLightStopLines(perceptionTrafficLightDecisions) {
    // 清除旧的绘制内容
    this.clearPerceptionTrafficLightStopLines();
    
    if (!perceptionTrafficLightDecisions || perceptionTrafficLightDecisions.length === 0) {
      return;
    }

    for (let i = 0; i < perceptionTrafficLightDecisions.length; i++) {
      const decision = perceptionTrafficLightDecisions[i];
      const stopLinePoints = decision.stopLinePoint;
      const trafficLightLightPoints = decision.trafficLightLightPoint;
      const trafficLightIds = decision.trafficLightIds || [];
      const stopLineId = decision.stopLineId;
      
      // 1. 绘制停止线（stopLinePoint是停止线的起终点折线）
      if (stopLinePoints && stopLinePoints.length >= 2) {
        const geometry = new THREE.BufferGeometry();
        const vertices = [];
        
        for (let j = 0; j < stopLinePoints.length; j++) {
          const point = stopLinePoints[j];
          vertices.push(
            point.x + this.current_x,
            point.y + this.current_y,
            point.z || 0.1
          );
        }
        
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        
        const material = new THREE.LineDashedMaterial({
          color: 0xffffff,
          linewidth: 2,
          scale: 1,
          dashSize: 1,
          gapSize: 0.5,
        });
        
        const stopLine = new THREE.Line(geometry, material);
        stopLine.computeLineDistances();
        stopLine.visible = true;
        stopLine.name = `perception_stop_line_${i}`;
        
        this.groupPerceptionTrafficLights.add(stopLine);
        
        // 在停止线中点绘制stopLineId标签
        if (stopLineId) {
          const midIndex = Math.floor(stopLinePoints.length / 2);
          const midPoint = stopLinePoints[midIndex];
          
          const textSprite = this.createTextSprite(stopLineId, '#ffff00', 'bold 24px Arial');
          textSprite.position.set(
            this.current_x + midPoint.x,
            this.current_y + midPoint.y,
            0
          );
          textSprite.name = `perception_stop_line_label_${i}`;
          this.groupPerceptionTrafficLights.add(textSprite);
        }
      }
      
      // 2. 绘制红绿灯图标（trafficLightLightPoint是红绿灯的坐标位置）
      if (trafficLightLightPoints && trafficLightLightPoints.length > 0) {
        for (let j = 0; j < trafficLightLightPoints.length; j++) {
          const point = trafficLightLightPoints[j];
          const lightId = trafficLightIds[j] || '';
          
          // 创建红绿灯图标（参考障碍物的创建方式）
          const geometry = new THREE.Geometry();
          geometry.dynamic = true;
          geometry.vertices.push(new THREE.Vector3(0, 0, 0));
          
          const material = new THREE.PointsMaterial({
            size: 32,
            sizeAttenuation: false,
            map: this.trafficLightTexture,
            alphaTest: 0.5,
            transparent: true,
            depthWrite: false,
          });
          
          const icon = new THREE.Points(geometry, material);
          icon.position.set(
            this.current_x + point.x,
            this.current_y + point.y,
            0
          );
          
          icon.name = `perception_traffic_light_icon_${i}_${j}`;
          this.groupPerceptionTrafficLights.add(icon);
          
          // 在红绿灯图标旁边绘制trafficLightIds标签
          if (lightId) {
            const textSprite = this.createTextSprite(lightId, '#ffffff', 'bold 24px Arial');
            textSprite.position.set(
              this.current_x + point.x + 1.5, // 紧贴图标（图标宽度3米，偏移1.5米）
              this.current_y + point.y,
              0
            );
            textSprite.name = `perception_traffic_light_label_${i}_${j}`;
            this.groupPerceptionTrafficLights.add(textSprite);
          }
        }
      }
    }
  }

  // 创建文字精灵
  createTextSprite(text, color = '#BFBFBF', font = 'bold 20px Arial') {
    // 计算动态Canvas尺寸
    const charWidth = 12;
    const padding = 20;
    const canvasWidth = Math.max(64, Math.min(256, text.length * charWidth + padding));
    const canvasHeight = 64;
    
    const canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    
    const context = canvas.getContext('2d');
    context.imageSmoothingQuality = 'high';
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = font;
    context.fillStyle = color;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, canvas.width / 2, canvas.height / 2);
    
    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;
    
    const material = new THREE.SpriteMaterial({ 
      map: texture,
      sizeAttenuation: true,
      depthWrite: false,
    });
    
    const sprite = new THREE.Sprite(material);
    sprite.scale.set(2.5, 1.25, 1);
    sprite.renderOrder = 100;
    
    return sprite;
  }

  // 清除感知红绿灯绘制内容
  clearPerceptionTrafficLightStopLines() {
    while (this.groupPerceptionTrafficLights.children.length > 0) {
      const child = this.groupPerceptionTrafficLights.children[0];
      this.groupPerceptionTrafficLights.remove(child);
      if (child.geometry) child.geometry.dispose();
      if (child.material && child.material.map) {
        child.material.map.dispose();
      }
      if (child.material) {
        child.material.dispose();
      }
    }
  }

  // ========== 旧版红绿灯兼容函数 ==========
  
  // 绘制旧版红绿灯列表（完全恢复旧版逻辑）
  drawLightList(trafficLight, interestedLight) {
    if (trafficLight) {
      let lightInfoList = this.GenerateInterestTrafficLightInfo(
        trafficLight,
        interestedLight
      );
      if (lightInfoList.length > 0) {
        this.setState({ lightInfoList });
        return;
      }
      lightInfoList = this.GenerateAllTrafficLightInfo(trafficLight);
      this.setState({ lightInfoList });
    }
  }

  GenerateInterestTrafficLightInfo(trafficLight, interestedLight) {
    let lightInfoList = [];
    if (trafficLight) {
      if (interestedLight && interestedLight.length > 0) {
        for (let i = 0; i < interestedLight.length; i++) {
          let planningTrafficLight = interestedLight[i];
          let id = planningTrafficLight.id;
          let light = this.GetTrafficLight(trafficLight, id);
          let trafficLightInfo = this.GenerateTrafficLightInfo(light);
          if (trafficLightInfo) {
            lightInfoList.push(trafficLightInfo);
          }
        }
      }
    }
    return lightInfoList;
  }

  GenerateAllTrafficLightInfo(trafficLight) {
    let lightInfoList = [];
    if (trafficLight) {
      for (let i = 0; i < trafficLight.length; i++) {
        let light = trafficLight[i];
        let trafficLightInfo = this.GenerateTrafficLightInfo(light);
        if (trafficLightInfo) lightInfoList.push(trafficLightInfo);
      }
    }
    return lightInfoList;
  }

  GetTrafficLight(trafficLight, id) {
    if (trafficLight) {
      for (let i = 0; i < trafficLight.length; i++) {
        if (trafficLight[i].id === id) {
          return trafficLight[i];
        }
      }
    }
    return null;
  }

  GenerateTrafficLightInfo(light) {
    if (!light) return null;
    
    let id = light.id;
    let trafficLightInfo = {
      id: id,
      duration: light.duration || 0,
      showLight: true,
      style_text_red: 'light_red_unknown',
      style_text_green: 'light_green_unknown',
      style_text_yellow: 'light_yellow_unknown',
      trafficLightStateText: '未知',
    };
    
    // 处理light状态
    if (light.light === 1) {
      trafficLightInfo = {
        id: id,
        duration: light.duration || 0,
        showLight: true,
        style_text_red: 'light_red_major',
        style_text_green: 'light_green_unknown',
        style_text_yellow: 'light_yellow_unknown',
        trafficLightStateText: '红灯',
      };
    } else if (light.light === 2) {
      trafficLightInfo = {
        id: id,
        duration: light.duration || 0,
        showLight: true,
        style_text_red: 'light_red_unknown',
        style_text_green: 'light_green_major',
        style_text_yellow: 'light_yellow_unknown',
        trafficLightStateText: '绿灯',
      };
    } else if (light.light === 3) {
      trafficLightInfo = {
        id: id,
        duration: light.duration || 0,
        showLight: true,
        style_text_red: 'light_red_unknown',
        style_text_green: 'light_green_unknown',
        style_text_yellow: 'light_yellow_major',
        trafficLightStateText: '黄灯',
      };
    } else if (light.light === 4) {
      trafficLightInfo = {
        id: id,
        duration: light.duration || 0,
        showLight: true,
        style_text_red: 'light_black',
        style_text_green: 'light_black',
        style_text_yellow: 'light_black',
        trafficLightStateText: '红绿灯不亮',
      };
    }
    
    // 处理multiFrameState闪烁状态（覆盖基础状态）
    if (light.multiFrameState === 1) { // FLASHING_GREEN
      trafficLightInfo = {
        ...trafficLightInfo,
        style_text_red: 'light_red_unknown',
        style_text_green: 'light_green_twinkle',
        style_text_yellow: 'light_yellow_unknown',
        trafficLightStateText: '绿灯闪烁',
      };
    } else if (light.multiFrameState === 2) { // FLASHING_RED
      trafficLightInfo = {
        ...trafficLightInfo,
        style_text_red: 'light_red_twinkle',
        style_text_green: 'light_green_unknown',
        style_text_yellow: 'light_yellow_unknown',
        trafficLightStateText: '红灯闪烁',
      };
    } else if (light.multiFrameState === 3) { // FLASHING_YELLOW
      trafficLightInfo = {
        ...trafficLightInfo,
        style_text_red: 'light_red_unknown',
        style_text_green: 'light_green_unknown',
        style_text_yellow: 'light_yellow_twinkle',
        trafficLightStateText: '黄灯闪烁',
      };
    }
    
    return trafficLightInfo;
  }

  // 绘制旧版红绿灯（向前兼容）
  drawOldTrafficLights(trafficLights) {
    // 清除旧的绘制内容
    this.clearPerceptionTrafficLightStopLines();
    
    if (!trafficLights || trafficLights.length === 0) {
      this.setState({ perceptionLightInfoList: [] });
      return;
    }

    const perceptionLightInfoList = [];
    
    // 旧版灯态映射
    const lightStateMap = {
      0: { text: '未知', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      1: { text: '红灯', style_red: 'light_red_major', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      2: { text: '绿灯', style_red: 'light_red_unknown', style_green: 'light_green_major', style_yellow: 'light_yellow_unknown' },
      3: { text: '黄灯', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_major' },
      4: { text: '黑灯', style_red: 'light_black', style_green: 'light_black', style_yellow: 'light_black' },
    };

    for (let i = 0; i < trafficLights.length; i++) {
      const light = trafficLights[i];
      const position = light.position;
      const lightId = light.id || '';
      const lightState = lightStateMap[light.light] || lightStateMap[0];
      
      // 绘制红绿灯图标
      if (position) {
        const geometry = new THREE.Geometry();
        geometry.dynamic = true;
        geometry.vertices.push(new THREE.Vector3(0, 0, 0));
        
        const material = new THREE.PointsMaterial({
          size: 32,
          sizeAttenuation: false,
          map: this.trafficLightTexture,
          alphaTest: 0.5,
          transparent: true,
          depthWrite: false,
        });
        
        const icon = new THREE.Points(geometry, material);
        icon.position.set(
          this.current_x + position.x,
          this.current_y + position.y,
          0
        );
        
        icon.name = `old_traffic_light_icon_${i}`;
        this.groupPerceptionTrafficLights.add(icon);
        
        // 绘制ID标签
        if (lightId) {
          const textSprite = this.createTextSprite(lightId, '#ffffff', 'bold 24px Arial');
          textSprite.position.set(
            this.current_x + position.x + 1.5,
            this.current_y + position.y,
            0
          );
          textSprite.name = `old_traffic_light_label_${i}`;
          this.groupPerceptionTrafficLights.add(textSprite);
        }
      }
      
      // 添加到UI列表（用于展开显示）
      const lightInfo = {
        id: lightId,
        showLight: true,
        duration: light.remainingSecs || 0,
        turnType: '红绿灯', // 旧版没有方向信息
        style_text_red: lightState.style_red,
        style_text_green: lightState.style_green,
        style_text_yellow: lightState.style_yellow,
        trafficLightStateText: lightState.text,
      };
      
      perceptionLightInfoList.push(lightInfo);
    }
    
    this.setState({ perceptionLightInfoList });
  }

  // 绘制PNC看灯结果列表
  drawPncTrafficLightList(trafficLightInformations) {
    if (!trafficLightInformations || trafficLightInformations.length === 0) {
      this.setState({ lightInfoList: [] });
      return;
    }

    const lightInfoList = [];
    
    for (let i = 0; i < trafficLightInformations.length; i++) {
      const info = trafficLightInformations[i];
      
      // 将light_shape枚举值转换为文字（替代turn_type）
      const lightShapeMap = {
        0: '未知',
        1: '掉头',
        2: '左转',
        3: '直行',
        4: '右转',
        5: '圆灯',
      };
      
      // 将light_state枚举值转换为样式和文字
      const lightStateMap = {
        0: { text: '未知', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
        1: { text: '红灯', style_red: 'light_red_major', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
        2: { text: '绿灯', style_red: 'light_red_unknown', style_green: 'light_green_major', style_yellow: 'light_yellow_unknown' },
        3: { text: '黄灯', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_major' },
        4: { text: '红闪', style_red: 'light_red_twinkle', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
        5: { text: '绿闪', style_red: 'light_red_unknown', style_green: 'light_green_twinkle', style_yellow: 'light_yellow_unknown' },
        6: { text: '黄闪', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_twinkle' },
        7: { text: '黑灯', style_red: 'light_black', style_green: 'light_black', style_yellow: 'light_black' },
        8: { text: '未检测', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
        9: { text: '未知', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      };
      
      const turnType = lightShapeMap[info.lightShape] || '未知';
      const lightState = lightStateMap[info.lightState] || lightStateMap[0];
      
      const lightInfo = {
        id: info.trafficLightId || info.stopLineId || `light_${i}`,
        showLight: true,
        duration: 0,
        turnType: turnType,
        style_text_red: lightState.style_red,
        style_text_green: lightState.style_green,
        style_text_yellow: lightState.style_yellow,
        trafficLightStateText: lightState.text, // 只显示灯态，不拼接方向
      };
      
      lightInfoList.push(lightInfo);
    }
    
    this.setState({ lightInfoList });
  }

  // 绘制感知看灯结果列表（固定展示5个灯型）
  drawPerceptionTrafficLightList(perceptionTrafficLightDecisions) {
    if (!perceptionTrafficLightDecisions || perceptionTrafficLightDecisions.length === 0) {
      this.setState({ perceptionLightInfoList: [] });
      return;
    }

    const perceptionLightInfoList = [];
    
    // 固定5个灯型
    const shapeTypes = [
      { key: 'uturnShape', name: '掉头' },
      { key: 'leftShape', name: '左转' },
      { key: 'straightShape', name: '直行' },
      { key: 'rightShape', name: '右转' },
      { key: 'circleShape', name: '圆灯' },
    ];
    
    // 灯态映射
    const lightStateMap = {
      0: { text: '未知', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      1: { text: '红灯', style_red: 'light_red_major', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      2: { text: '绿灯', style_red: 'light_red_unknown', style_green: 'light_green_major', style_yellow: 'light_yellow_unknown' },
      3: { text: '黄灯', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_major' },
      4: { text: '红闪', style_red: 'light_red_twinkle', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      5: { text: '绿闪', style_red: 'light_red_unknown', style_green: 'light_green_twinkle', style_yellow: 'light_yellow_unknown' },
      6: { text: '黄闪', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_twinkle' },
      7: { text: '黑灯', style_red: 'light_black', style_green: 'light_black', style_yellow: 'light_black' },
      8: { text: '未检测', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
      9: { text: '未知', style_red: 'light_red_unknown', style_green: 'light_green_unknown', style_yellow: 'light_yellow_unknown' },
    };

    // 遍历所有perceptionTrafficLightDecisions，合并每种灯型的状态
    const shapeStates = {};
    
    for (let i = 0; i < perceptionTrafficLightDecisions.length; i++) {
      const decision = perceptionTrafficLightDecisions[i];
      
      for (let j = 0; j < shapeTypes.length; j++) {
        const shapeKey = shapeTypes[j].key;
        const shape = decision[shapeKey];
        
        if (shape && shape.state !== undefined) {
          // 如果该灯型还没有记录，或者有状态值则更新
          if (!shapeStates[shapeKey] || shape.state !== 0) {
            shapeStates[shapeKey] = shape;
          }
        }
      }
    }

    // 固定生成5个灯型的显示项
    for (let i = 0; i < shapeTypes.length; i++) {
      const shapeType = shapeTypes[i];
      const shape = shapeStates[shapeType.key];
      
      // 如果没有数据，显示未知状态
      const state = (shape && shape.state !== undefined) ? shape.state : 0;
      const lightState = lightStateMap[state] || lightStateMap[0];
      
      const lightInfo = {
        id: `shape_${shapeType.key}`,
        showLight: true,
        duration: shape?.remain || 0,
        turnType: shapeType.name,
        style_text_red: lightState.style_red,
        style_text_green: lightState.style_green,
        style_text_yellow: lightState.style_yellow,
        trafficLightStateText: lightState.text,
      };
      
      perceptionLightInfoList.push(lightInfo);
    }
    
    this.setState({ perceptionLightInfoList });
  }

  draw_buffer_routing(routing) {
    let routing_pts = routing.routingLine;
    let length = routing_pts.length;
    if (length < 2) return;
    this.material_label_start.visible = false;
    this.material_label_end.visible = false;
    let buffer = this.GetBuffer(
      this.GeometryType.LINE_STRIP,
      length,
      this.routing_buffer,
      this.material_routing_info
    );
    let vertices = buffer.geometry.vertices;
    for (let j = 0; j < routing_pts.length; j++) {
      vertices[j].set(routing_pts[j].x, routing_pts[j].y, 0);
    }
    buffer.geometry.verticesNeedUpdate = true;
    buffer.line.position.set(this.current_x, this.current_y, 0);
    buffer.material.visible = true;
    this.group_label_start.position.x = this.current_x + routing_pts[0].x;
    this.group_label_start.position.y = this.current_y + routing_pts[0].y;
    this.group_label_start.position.z = 0;
    this.group_label_end.position.x =
      this.current_x + routing_pts[length - 1].x;
    this.group_label_end.position.y =
      this.current_y + routing_pts[length - 1].y;
    this.group_label_end.position.z = 0;
    this.material_label_start.visible = true;
    this.material_label_end.visible = true;
  }

  getPolygonPts(pts, width, fz) {
    var vecPoint = [];
    for (let j = 0; j < pts.length; j++) {
      vecPoint.push(new THREE.Vector3(pts[j].x, pts[j].y, 0.1));
    }
    let vecPoint1 = [];
    let vecPoint2 = [];
    let tmpPos;
    let direction = new THREE.Vector3(0, 0, 0);
    let normal_direction;
    let direction_up = new THREE.Vector3(0, 0, 1);
    let direction_out = new THREE.Vector3(0, 0, 0);
    let nSize = vecPoint.length;
    let fromPos, toPos;
    if (nSize < 2) return;
    for (let i = 0; i < vecPoint.length; i++) {
      tmpPos = vecPoint[i];
      if (i === 0) {
        fromPos = tmpPos;
        toPos = vecPoint[i + 1];
      } else if (i === nSize - 1) {
        fromPos = vecPoint[i - 1];
        toPos = tmpPos;
      } else {
        fromPos = vecPoint[i - 1];
        toPos = vecPoint[i + 1];
      }
      direction.subVectors(toPos, fromPos);
      direction.normalize();
      direction_up = new THREE.Vector3(0, 0, 1);
      normal_direction = direction_up.cross(direction);
      normal_direction.normalize();
      normal_direction.multiplyScalar(width);
      direction_out.addVectors(tmpPos, normal_direction);
      vecPoint1.push(new THREE.Vector3(direction_out.x, direction_out.y, fz));
      direction_out.subVectors(tmpPos, normal_direction);
      vecPoint2.push(new THREE.Vector3(direction_out.x, direction_out.y, fz));
    }

    let polygon_pts = [];
    for (let i = 0; i < vecPoint1.length; i++) {
      polygon_pts.push(
        new THREE.Vector3(vecPoint1[i].x, vecPoint1[i].y, vecPoint1[i].z)
      );
    }
    for (let i = nSize - 1; i >= 0; i--) {
      polygon_pts.push(
        new THREE.Vector3(vecPoint2[i].x, vecPoint2[i].y, vecPoint2[i].z)
      );
    }
    vecPoint1 = [];
    vecPoint2 = [];
    vecPoint = [];
    return polygon_pts;
  }

  draw_planning_buffer(planning_pb) {
    if (planning_pb.trajectory.length > 1) {
      let key = planning_pb.trajectory.length * 2;
      let polygon_pts = this.getPolygonPts(planning_pb.trajectory, 0.5, 0);
      let buffer_pool_map = this.trajectory_polygon_buffer;
      let material = this.material_trajectory;
      let buffer = this.GetBuffer(
        this.GeometryType.POLYGON,
        key,
        buffer_pool_map,
        material
      );
      let vertices = buffer.geometry.vertices;
      for (let i = 0; i < vertices.length && polygon_pts.length; i++) {
        let pt = polygon_pts[i];
        vertices[i].set(pt.x, pt.y, pt.z);
      }
      buffer.geometry.verticesNeedUpdate = true;
      buffer.mesh.position.set(this.current_x, this.current_y, 0);
      buffer.material.visible = true;
      polygon_pts = [];
    }

    if (planning_pb.path.length > 1) {
      let key = planning_pb.path.length * 2;
      let polygon_pts = this.getPolygonPts(planning_pb.path, 0.1, 0.2);
      let buffer_pool_map = this.planning_path_polygon_buffer;
      let material = this.material_planning;
      let buffer = this.GetBuffer(
        this.GeometryType.POLYGON,
        key,
        buffer_pool_map,
        material
      );
      let vertices = buffer.geometry.vertices;
      for (let i = 0; i < vertices.length && polygon_pts.length; i++) {
        let pt = polygon_pts[i];
        vertices[i].set(pt.x, pt.y, pt.z);
      }
      buffer.geometry.verticesNeedUpdate = true;
      buffer.mesh.position.set(this.current_x, this.current_y, 0);
      buffer.material.visible = true;
      polygon_pts = [];
    }
    this.updateParkingGoals(planning_pb.parkingGoal);
  }

  AllocateLineBuffer(type, nkey, buffer_pool_map, mat, count = 1) {
    let buffers = [];
    if (buffer_pool_map.has(nkey)) buffers = buffer_pool_map.get(nkey).buffers; //continune add buffer

    for (let i = 0; i < count; i++) {
      var buffer_geometry = new THREE.Geometry();
      buffer_geometry.dynamic = true;

      for (let j = 0; j < nkey; j++) {
        buffer_geometry.vertices.push(
          new THREE.Vector3(
            Math.floor(Math.random() * 10 - 5),
            Math.floor(Math.random() * 10 - 5),
            0
          )
        );
      }

      var material = new THREE.LineBasicMaterial({
        color: 0x00ff00,
        linewidth: 1,
      });
      material.copy(mat);
      material.visible = false;

      var line = null;
      if (type === this.GeometryType.LINE_LOOP)
        line = new THREE.LineLoop(buffer_geometry, material);
      else if (type === this.GeometryType.LINE_STRIP)
        line = new THREE.Line(buffer_geometry, material);
      else line = new THREE.LineSegments(buffer_geometry, material);

      line.position.set(
        Math.floor(Math.random() * 10 - 5),
        Math.floor(Math.random() * 10 - 5),
        0
      );
      var buff_obj = {
        geometry: buffer_geometry,
        material: material,
        line: line,
      };

      buffers.push(buff_obj);
      this.scene.add(line);
    }

    if (!buffer_pool_map.has(nkey)) {
      var buffer_data = { buffers: buffers, index: 0 };
      buffer_pool_map.set(nkey, buffer_data);
    }
  }

  AllocatePolyCubeBuffer(nkey, buffer_pool_map, material, count = 1) {
    let buffers = [];
    if (buffer_pool_map.has(nkey)) buffers = buffer_pool_map.get(nkey).buffers; //continune add buffer

    let thetaLength = Math.PI * 2;
    let thetaStart = 0;
    let radius = 1;
    let height = 1;

    for (let i = 0; i < count; i++) {
      let vertices = [];
      let faces = [];
      let radialSegments = nkey;
      for (let x = 0; x < radialSegments; x++) {
        var u = x / radialSegments;
        var theta = u * thetaLength + thetaStart;
        var cosTheta = Math.cos(theta);
        var sinTheta = Math.sin(theta);

        let x0 = radius * cosTheta;
        let y0 = radius * sinTheta;
        vertices.push(new THREE.Vector3(x0, y0, 0));
        vertices.push(new THREE.Vector3(x0, y0, height));
      }
      for (let j = 0; j < radialSegments - 1; j++) {
        faces.push(new THREE.Face3(2 * j + 1, 2 * j, 2 * j + 2));
        faces.push(new THREE.Face3(2 * j + 3, 2 * j + 1, 2 * j + 2));
      }
      faces.push(new THREE.Face3(0, 1, 2 * radialSegments - 1));
      faces.push(
        new THREE.Face3(2 * radialSegments - 1, 2 * radialSegments - 2, 0)
      );

      faces.push(new THREE.Face3(0, 2, 4));
      for (let j = 3; j < radialSegments; j++) {
        faces.push(new THREE.Face3(0, (j - 1) * 2, j * 2));
      }
      faces.push(new THREE.Face3(1, 3, 5));
      for (let j = 3; j < radialSegments; j++) {
        faces.push(new THREE.Face3(1, (j - 1) * 2 + 1, j * 2 + 1));
      }

      let geom = new THREE.Geometry();
      geom.dynamic = true;
      geom.verticesNeedUpdate = true;
      geom.vertices = vertices;
      geom.faces = faces;

      let material2 = new THREE.MeshLambertMaterial({
        side: THREE.DoubleSide,
        color: 0xdfdfdf,
      });
      material2.copy(material);
      var mesh = new THREE.Mesh(geom, material2);

      let rand_x = Math.floor(Math.random() * 10 - 5);
      let rand_y = Math.floor(Math.random() * 10 - 5);
      mesh.position.set(rand_x, rand_y, 0);

      material2.visible = false;
      const buff_obj = { geometry: geom, material: material2, mesh: mesh };
      buffers.push(buff_obj);
      this.scene.add(mesh);
    }

    if (!buffer_pool_map.has(nkey)) {
      var buffer_data = { buffers: buffers, index: 0 };
      buffer_pool_map.set(nkey, buffer_data);
    }
  }

  AllocatePolygonBuffer(nkey, buffer_pool_map, material, count = 1) {
    let buffers = [];
    if (buffer_pool_map.has(nkey)) buffers = buffer_pool_map.get(nkey).buffers; //continune add buffer

    let index_end = nkey / 2;
    let index_max = index_end * 2;
    for (let i = 0; i < count; i++) {
      var geom = new THREE.Geometry();
      for (let j = 0; j < index_max; j++) {
        geom.vertices.push(
          new THREE.Vector3(
            Math.floor(Math.random() * 10 - 5),
            Math.floor(Math.random() * 10 - 5),
            0
          )
        );
      }
      let faces = [];
      for (let k = 0; k < index_end - 1; k++) {
        faces.push(new THREE.Face3(k, index_max - k - 1, index_max - k - 2));
        faces.push(new THREE.Face3(k + 1, k, index_max - k - 2));
      }
      geom.dynamic = true;
      geom.verticesNeedUpdate = true;
      geom.faces = faces;

      let material2 = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        color: 0xdfdfdf,
      });
      material2.copy(material);

      var mesh = new THREE.Mesh(geom, material2);
      let rand_x = Math.floor(Math.random() * 10 - 5);
      let rand_y = Math.floor(Math.random() * 10 - 5);
      mesh.position.set(rand_x, rand_y, 0);
      material2.visible = false;

      var buff_obj = { geometry: geom, material: material2, mesh: mesh };
      buffers.push(buff_obj);
      this.scene.add(mesh);
    }
    if (!buffer_pool_map.has(nkey)) {
      var buffer_data = { buffers: buffers, index: 0 };
      buffer_pool_map.set(nkey, buffer_data);
    }
  }

  AllocateLabelBuffer(nkey, buffer_pool_map, material, count = 1) {
    let buffers = [];
    if (buffer_pool_map.has(nkey)) {
      buffers = buffer_pool_map.get(nkey).buffers;
    }
    for (let i = 0; i < count; i++) {
      let geometry = new THREE.Geometry();
      geometry.dynamic = true;
      geometry.vertices.push(new THREE.Vector3(0, 0, 0.7));
      let mat = new THREE.PointsMaterial({
        size: 32,
        sizeAttenuation: false,
        map: this.texture_cube[0],
        alphaTest: 0.5,
        transparent: true,
      });
      mat.copy(material);
      mat.visible = false;
      let mesh = new THREE.Points(geometry, mat);
      mesh.position.set(
        Math.floor(Math.random() * 10 - 5),
        Math.floor(Math.random() * 10 - 5),
        0
      );
      var buff_obj = { geometry: geometry, material: mat, mesh: mesh };
      buffers.push(buff_obj);
      this.scene.add(mesh);
    }
    if (!buffer_pool_map.has(nkey)) {
      var buffer_data = { buffers: buffers, index: 0 };
      buffer_pool_map.set(nkey, buffer_data);
    }
  }

  AllocateBuffer(type, nkey, buffer_pool_map, mat, count = 1) {
    if (
      type === this.GeometryType.LINE_LOOP ||
      type === this.GeometryType.LINE_STRIP ||
      type === this.GeometryType.LINE_SEGMENT
    ) {
      this.AllocateLineBuffer(type, nkey, buffer_pool_map, mat, count);
    } else if (type === this.GeometryType.CONVEX) {
      this.AllocatePolyCubeBuffer(nkey, buffer_pool_map, mat, count);
    } else if (type === this.GeometryType.POLYGON) {
      this.AllocatePolygonBuffer(nkey, buffer_pool_map, mat, count);
    } else if (type === this.GeometryType.SYMBOL) {
      this.AllocateLabelBuffer(nkey, buffer_pool_map, mat, count);
    } else {
      console.error('invalid buffer type' + type);
    }
  }

  GetBuffer(type, key, buffer_pool_map, material) {
    let reallocate_size = 5;
    if (!buffer_pool_map.has(key)) {
      this.AllocateBuffer(
        type,
        key,
        buffer_pool_map,
        material,
        reallocate_size
      );
    } else {
      let buffer_pool = buffer_pool_map.get(key);
      if (buffer_pool.buffers.length === buffer_pool.index) {
        this.AllocateBuffer(
          type,
          key,
          buffer_pool_map,
          material,
          reallocate_size
        );
      }
    }
    let buffer_pool = buffer_pool_map.get(key);
    let index = buffer_pool.index;
    buffer_pool.index += 1;
    if (buffer_pool.buffers.length > index) return buffer_pool.buffers[index];
    return null;
  }

  draw_buffer_obstacles(obstacle_list) {
    if (obstacle_list.length !== 0) {
      for (let i = 0; i < obstacle_list.length; i++) {
        let obstacle = obstacle_list[i];
        let obs_type = obstacle.obstacleType;
        let msg_points = obstacle.polygon;
        if (msg_points.length < 3) {
          continue;
        }
        let key = msg_points.length;
        let height = obstacle.height;
        {
          let buffer = this.GetBuffer(
            this.GeometryType.CONVEX,
            key,
            this.convex_buffer_map,
            this.material_cubes_mesh[obs_type]
          );
          if (buffer === null) {
            console.error('Convex error,get buffer failed');
          } else {
            buffer.geometry.verticesNeedUpdate = true;
            buffer.geometry.normalsNeedUpdate = true;
            let vertices = buffer.geometry.vertices;
            for (let i = 0; i < msg_points.length; i++) {
              let x = msg_points[i].x;
              let y = msg_points[i].y;
              vertices[2 * i].set(x, y, 0);
              vertices[2 * i + 1].set(x, y, height);
            }
            buffer.material.copy(this.material_cubes_mesh[obs_type]);
            buffer.mesh.position.set(this.current_x, this.current_y, 0);
            buffer.material.visible = true;
            buffer.geometry.computeBoundingSphere();
            buffer.geometry.computeFaceNormals();
          }
        }
        {
          let key_line_segment = key * 6;
          let buffer = this.GetBuffer(
            this.GeometryType.LINE_SEGMENT,
            key_line_segment,
            this.cube_pillar_map,
            this.material_cubes[obs_type]
          );
          let vertices = buffer.geometry.vertices;
          let x = 0;
          let y = 0;
          let x1 = 0;
          let y1 = 0;
          for (let i = 0; i < msg_points.length; i++) {
            x = msg_points[i].x;
            y = msg_points[i].y;

            vertices[6 * i].set(x, y, 0);
            vertices[6 * i + 1].set(x, y, height);
            if (i < msg_points.length - 1) {
              x1 = msg_points[i + 1].x;
              y1 = msg_points[i + 1].y;
            } else {
              x1 = msg_points[0].x;
              y1 = msg_points[0].y;
            }
            vertices[6 * i + 2].set(x, y, 0);
            vertices[6 * i + 3].set(x1, y1, 0);
            vertices[6 * i + 4].set(x, y, height);
            vertices[6 * i + 5].set(x1, y1, height);
          }
          buffer.geometry.verticesNeedUpdate = true;
          buffer.material.copy(this.material_cubes[obs_type]);
          buffer.line.position.set(this.current_x, this.current_y, 0);
          buffer.material.visible = true;
          buffer.geometry.computeBoundingSphere();
        }
        {
          let key_symbol = obs_type;
          let show = true;
          if (key_symbol == 18 && !this.state.showImageOcc) {
            show = false;
          }
          let buffer = this.GetBuffer(
            this.GeometryType.SYMBOL,
            key_symbol,
            this.cube_label_map,
            this.material_icon_cube[obs_type]
          );
          if (buffer && show) {
            buffer.geometry.verticesNeedUpdate = true;
            let sum_x = 0;
            let sum_y = 0;
            for (let i = 0; i < msg_points.length; i++) {
              let x = msg_points[i].x;
              let y = msg_points[i].y;
              sum_x += x;
              sum_y += y;
            }
            sum_x = sum_x / key;
            sum_y = sum_y / key;
            buffer.mesh.position.set(
              this.current_x + sum_x,
              this.current_y + sum_y,
              height
            );
            buffer.material.visible = true;
          }
        }
        {
          let vehicle_light_state = obstacle.vehicleLightState;
          if (vehicle_light_state === 5) {
            let buffer = this.GetBuffer(
              this.GeometryType.SYMBOL,
              18,
              this.cube_label_map,
              this.material_icon_cube[18]
            );
            if (buffer) {
              buffer.geometry.verticesNeedUpdate = true;
              if (msg_points.length == 4) {
                let param = msg_points.map((item) => [item.x, item.y]);
                let pos = this.getTailLightPosition(param);
                buffer.mesh.position.set(
                  this.current_x + pos[0],
                  this.current_y + pos[1],
                  height
                );
                buffer.material.visible = true;
              }
            }
          }
        }
        {
          let trajectory = obstacle.trajectory;
          let key_trajectory = trajectory.length;
          let buffer = this.GetBuffer(
            this.GeometryType.LINE_STRIP,
            key_trajectory,
            this.cube_trajectory_map,
            this.material_cubes[obs_type]
          );
          let vertices = buffer.geometry.vertices;
          for (let i = 0; i < trajectory.length; i++) {
            let x = trajectory[i].x;
            let y = trajectory[i].y;
            vertices[i].set(x, y, 0.1);
          }
          buffer.geometry.verticesNeedUpdate = true;
          buffer.material.copy(this.material_cubes[obs_type]);
          buffer.line.position.set(this.current_x, this.current_y, 0);
          buffer.material.visible = true;
          buffer.geometry.computeBoundingSphere();
        }
      }
    }
  }

  getTailLightPosition(points) {
    function distance(p1, p2) {
      return Math.sqrt(Math.pow(p2[0] - p1[0], 2) + Math.pow(p2[1] - p1[1], 2));
    }
    function midpoint(p1, p2) {
      return [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];
    }
    const edges = [
      {
        points: [points[0], points[1]],
        length: distance(points[0], points[1]),
      },
      {
        points: [points[1], points[2]],
        length: distance(points[1], points[2]),
      },
      {
        points: [points[2], points[3]],
        length: distance(points[2], points[3]),
      },
      {
        points: [points[3], points[0]],
        length: distance(points[3], points[0]),
      },
    ];
    edges.sort((a, b) => a.length - b.length);
    const shortestEdges = edges.slice(0, 2);
    const midpoints = shortestEdges.map((edge) =>
      midpoint(edge.points[0], edge.points[1])
    );
    let closestMidpoint = midpoints[0];
    let closestDistance = distance([0, 0], midpoints[0]);
    midpoints.forEach((midpoint) => {
      const d = distance([0, 0], midpoint);
      if (d < closestDistance) {
        closestDistance = d;
        closestMidpoint = midpoint;
      }
    });
    return closestMidpoint;
  }

  IsShowSignalTop() {
    return this.camera_flag === 1;
  }

  draw_lane(lane) {
    //绘制道路
    if (lane.length !== 0) {
      for (let i = 0; i < lane.length; i++) {
        let item = lane[i];
        let id = lane[i].id;
        if (!this.set_lane_id.has(id)) {
          this.group_lanes.add(
            this.drawLineStrip(item.guideLine, this.material_lane)
          );
          this.set_lane_id.add(id);
        }
      }
    }
  }

  drawLineStrip(arr, style, is_virtual = false) {
    let vertexArray = [];
    for (let j = 0; j < arr.length; j++) {
      vertexArray.push(
        new THREE.Vector3(
          arr[j].x + this.current_x,
          arr[j].y + this.current_y,
          0
        )
      );
    }
    let geometry = new THREE.Geometry();
    vertexArray.forEach(function (val) {
      geometry.vertices.push(val);
    });
    let line = new THREE.Line(geometry, style);
    if (is_virtual) line.computeLineDistances();
    return line;
  }

  draw_double_linestrip(arr, style1, style2, width) {
    let points_left = [];
    let points_right = [];
    let tmpPos;
    let direction = new THREE.Vector3(0, 0, 0);
    let normal_direction;
    let direction_up = new THREE.Vector3(0, 0, 1);
    let direction_out = new THREE.Vector3(0, 0, 0);
    let nSize = arr.length;
    let fromPos, toPos;
    for (let i = 0; i < arr.length; i++) {
      tmpPos = new THREE.Vector3(arr[i].x, arr[i].y, 0);
      if (i === 0) {
        fromPos = tmpPos;
        toPos = new THREE.Vector3(arr[i + 1].x, arr[i + 1].y, 0);
      } else if (i === nSize - 1) {
        fromPos = new THREE.Vector3(arr[i - 1].x, arr[i - 1].y, 0);
        toPos = tmpPos;
      } else {
        fromPos = new THREE.Vector3(arr[i - 1].x, arr[i - 1].y, 0);
        toPos = new THREE.Vector3(arr[i + 1].x, arr[i + 1].y, 0);
      }
      direction.subVectors(toPos, fromPos);
      direction.normalize();
      direction_up = new THREE.Vector3(0, 0, 1);
      normal_direction = direction_up.cross(direction);
      normal_direction.normalize();
      normal_direction.multiplyScalar(width);
      direction_out.addVectors(tmpPos, normal_direction);
      points_left.push(
        new THREE.Vector3(direction_out.x, direction_out.y, 0.01)
      );
      direction_out.subVectors(tmpPos, normal_direction);
      points_right.push(
        new THREE.Vector3(direction_out.x, direction_out.y, 0.01)
      );
    }

    let node = new THREE.Group();
    node.add(
      this.createLineStrip(
        points_left,
        style1.material,
        this.check_is_virtual_line(style1.type)
      )
    );
    node.add(
      this.createLineStrip(
        points_right,
        style2.material,
        this.check_is_virtual_line(style2.type)
      )
    );
    return node;
  }

  createLineStrip(points, material, is_virtual = false) {
    let geometry = new THREE.Geometry();
    points.forEach(function (val) {
      geometry.vertices.push(val);
    });
    let line = new THREE.Line(geometry, material);
    if (is_virtual) line.computeLineDistances();
    return line;
  }

  check_is_virtual_line(type) {
    if (type === 0 || type === 1) {
      return true;
    } else {
      return false;
    }
  }

  draw_boundary(boundAry) {
    //绘制道路边界线
    for (let i = 0; i < boundAry.length; i++) {
      let boundary = boundAry[i];
      let id = boundary.id;
      let boundary_pts = boundary.line;
      let style_list = boundary.style;
      if (style_list.length === 1) {
        for (let j = 0; j < style_list.length; j++) {
          let style = style_list[j];
          let line_type = style.type;
          let mat = this.get_boundary_material(line_type, style.color);
          if (!this.set_boundary_id.has(id)) {
            let line_strip = this.drawLineStrip(
              boundary_pts,
              mat,
              this.check_is_virtual_line(line_type)
            );
            this.group_boundaries.add(line_strip);
            this.set_boundary_id.add(id);
          }
        }
      } else if (style_list.length === 2) {
        let mat1 = this.get_boundary_material(
          style_list[0].type,
          style_list[0].color
        );
        let mat2 = this.get_boundary_material(
          style_list[1].type,
          style_list[1].color
        );
        let mat_info_left = { material: mat1, type: style_list[0].type };
        let mat_info_right = { material: mat2, type: style_list[1].type };
        let double_line = this.draw_double_linestrip(
          boundary_pts,
          mat_info_left,
          mat_info_right,
          0.1,
          this.group_boundaries
        );
        if (!this.set_boundary_id.has(id)) {
          this.group_boundaries.add(double_line);
          this.set_boundary_id.add(id);
        }
      } else {
        if (!this.set_boundary_id.has(id)) {
          let line_strip = this.drawlinestrip(
            boundary_pts,
            this.material_boundary_dot_other,
            true
          );
          this.group_boundaries.add(line_strip);
          this.set_boundary_id.add(id);
        }
      }
    }
  }

  drawStopLine(stopLineData) {
    const materialSolidWhite = new THREE.LineBasicMaterial({ color: 0xffffff });
    for (let i = 0; i < stopLineData.length; i++) {
      const stopLine = stopLineData[i];
      const id = stopLine.id;
      const points = stopLine.point;
      if (!this.setStopLineId.has(id)) {
        let lineStrip = this.drawLineStrip(points, materialSolidWhite, false);
        this.groupStopLine.add(lineStrip);
        this.setStopLineId.add(id);
      }
    }
  }

  // 根据Gate类型获取对应材质
  get_gate_material(type) {
    switch (type) {
      case 1: // AUTO_GATE
        return this.material_gate_auto;
      case 2: // MANUAL_GATE
        return this.material_gate_manual;
      case 3: // BARRIER_GATE
        return this.material_gate_barrier;
      default: // UNKNOWN_TYPE
        return this.material_gate_unknown;
    }
  }

  // 绘制门数据可视化
  draw_gates(gates) {
    for (let i = 0; i < gates.length; i++) {
      const gate = gates[i];
      const id = gate.id;
      const points = gate.point;
      const type = gate.type;
      
      if (!this.set_gate_id.has(id)) {
        const material = this.get_gate_material(type);
        const lineStrip = this.drawLineStrip(points, material, false);
        this.group_gates.add(lineStrip);
        
        // 在Gate线中点添加文字标签 "gate-{id}"
        if (points && points.length > 0) {
          const midIndex = Math.floor(points.length / 2);
          const midPoint = points[midIndex];
          const labelText = `gate：${id}`;
          
          const textSprite = this.createTextSprite(labelText, '#ffffff', 'bold 24px Arial');
          textSprite.position.set(
            this.current_x + midPoint.x,
            this.current_y + midPoint.y,
            0.2  // 提高Z坐标，避免被线条遮挡
          );
          textSprite.name = `gate_label_${id}`;
          this.group_gates.add(textSprite);
        }
        
        this.set_gate_id.add(id);
      }
    }
  }

  get_boundary_material(type, color) {
    const material_boundary_solid_white = new THREE.LineBasicMaterial({
      color: 0xffffff,
    });
    const material_boundary_solid_yellow = new THREE.LineBasicMaterial({
      color: 0xffff00,
    });
    const material_boundary_solid_other = new THREE.LineBasicMaterial({
      color: 0x333333,
    });
    const material_boundary_dash_white = new THREE.LineDashedMaterial({
      color: 0xffffff,
      linewidth: 1,
      scale: 1,
      dashSize: 1,
      gapSize: 2,
    });
    const material_boundary_dash_yellow = new THREE.LineDashedMaterial({
      color: 0xffff00,
      linewidth: 1,
      scale: 1,
      dashSize: 1,
      gapSize: 2,
    });
    const material_boundary_dash_other = new THREE.LineDashedMaterial({
      color: 0x333333,
      linewidth: 1,
      scale: 1,
      dashSize: 1,
      gapSize: 2,
    });
    const material_boundary_dot_white = new THREE.LineDashedMaterial({
      color: 0xffffff,
      linewidth: 1,
      scale: 1,
      dashSize: 0.5,
      gapSize: 0.5,
    });
    const material_boundary_dot_yellow = new THREE.LineDashedMaterial({
      color: 0xffff00,
      linewidth: 1,
      scale: 1,
      dashSize: 0.5,
      gapSize: 0.5,
    });
    const material_boundary_dot_other = new THREE.LineDashedMaterial({
      color: 0x333333,
      linewidth: 1,
      scale: 1,
      dashSize: 0.5,
      gapSize: 0.5,
    });
    if (type === 0 && color === 1) return material_boundary_dot_yellow;
    else if (type === 0 && color === 2) return material_boundary_dot_white;
    else if (type === 1 && color === 0) return material_boundary_dash_other;
    else if (type === 1 && color === 1) return material_boundary_dash_yellow;
    else if (type === 1 && color === 2) return material_boundary_dash_white;
    else if (type === 2 && color === 0) return material_boundary_solid_other;
    else if (type === 2 && color === 1) return material_boundary_solid_yellow;
    else if (type === 2 && color === 2) return material_boundary_solid_white;
    else return material_boundary_dot_other;
  }

  verifyToken(_wsRef) {
    this._wsRef = _wsRef;
    const request = {
      eventType: 'VEHICLE_DATA',
      data: this.vehicleSn,
    };
    let string_request = this.props.openData
      ? JSON.stringify(this.props.openData)
      : JSON.stringify(request);
    this._wsRef.current.send(string_request);

    // 兜底：WebsocketCmp 只会在 sendData 变化时发送；如果 sendData 在 ws open 前就已经准备好，
    // 这里需要补发一次，保证回放场景能在“首帧就绪”前停在指定 startTime/pause。
    if (this.props.sendData) {
      try {
        this._wsRef.current.send(JSON.stringify(this.props.sendData));
      } catch (e) {}
    }
  }

  handleClose() {
    console.log(' ---- websocket closed ---- ');
  }

  formatTimestamp(timestamp) {
    const date = timestamp ? new Date(timestamp) : new Date();
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleData(data) {
    const messageTimestamp = new Date().getTime()
    //接收数据，提取并存储在数组
    const dataType = Object.prototype.toString.call(data);
    if (dataType !== '[object Blob]' && dataType !== '[object ArrayBuffer]') {
      return;
    }
    
    // ===== 帧丢弃优化: 解码前丢弃旧帧,只保留最新数据 =====
    // 将原始数据存入槽位,覆盖旧的未解码数据(直接丢弃字节,不解码)
    // 这样避免了无谓的解码开销,保证总是处理最新帧
    this.pendingRawData = {
      data: data,
      messageTimestamp: messageTimestamp
    };
    
    // 如果当前没有在解码,立即开始处理
    if (!this.isDecoding) {
      this.processPendingData();
    }
  }
  
  // 新增: 处理待解码数据的方法
  processPendingData() {
    // 如果没有待处理数据,直接返回
    if (!this.pendingRawData) {
      this.isDecoding = false;
      return;
    }
    
    // 取出最新的待处理数据
    const { data, messageTimestamp } = this.pendingRawData;
    this.pendingRawData = null; // 清空槽位
    this.isDecoding = true;     // 设置解码锁
    
    const decodeStartTimestamp = new Date().getTime(); // 记录开始解码的时间戳
    var reader = new FileReader();
    reader.readAsArrayBuffer(data);
    let _this = this;
    
    reader.onload = () => {
      const decodeStart = performance.now();
      var buf = new Uint8Array(reader.result);
      const message = local_view_type.decode(buf);
      const decodeEnd = performance.now();
      
      // 性能监控: 记录解码耗时
      const decodeTime = decodeEnd - decodeStart;
      _this.lastDecodeTime = decodeTime;
      
      if (decodeTime > 10) {
        console.warn(`[性能警告] Protobuf解码耗时: ${decodeTime.toFixed(2)}ms`);
      }

      if(this.debugFlag){
        const { topLidarTimestamp, createTimestamp, timestamp, processInfo } = message
        const proxyTimestamp = processInfo.proxyTimestamp
        const clientTimestamp = processInfo.clientTimestamp || messageTimestamp
        const currentTimestamp = new Date().getTime()
        const decodeQueueTime = decodeStartTimestamp - messageTimestamp; // 解码排队时间
        console.log(`当前时间：${this.formatTimestamp(currentTimestamp)},雷达到车端localview模块写数据时间：${(createTimestamp - topLidarTimestamp)/1000000}ms，写数据到hermes时间：${(timestamp - createTimestamp)/1000000}ms，hermes到端云时间：${(proxyTimestamp * 1000000 - timestamp)/1000000}ms，端云到socket发出时间：${(clientTimestamp - proxyTimestamp)}ms，socket发出到浏览器时间：${(messageTimestamp - clientTimestamp)}ms，解码排队时间：${decodeQueueTime}ms，前端解码时间：${decodeTime}ms`)
      }
      if (message.origin) {
        // 优化后的队列管理: 保留最近5帧数据,避免堆积
        if (_this.deque_dataview.length > 5) {
          _this.deque_dataview.shift(); // 移除最旧的数据
        }
        let kafkaTimestamp = message.timestamp;
        let proxyTimestamp = kafkaTimestamp;
        if (message.businessInfo)
          proxyTimestamp = message.businessInfo.proxyTimestamp * 1000000;
        var proxy_delay = (proxyTimestamp - kafkaTimestamp) / 1000000; //ms
        let current_time = new Date().getTime();

        const data_msg = {
          //从websocket获取到的单个可用数据
          time: message.createTimestamp,
          data_view: message,
          delay: proxy_delay,
          current_time: current_time,
          server_time: kafkaTimestamp,
          buffer_len: data.length,
        };
        _this.deque_dataview.push(data_msg);

        // 标记：已经收到首帧数据，下一次 render 后通知外部
        if (!_this.__firstFrameNotified) {
          _this.__firstFramePending = true;
        }
      }
      
      // 解码完成,释放锁,检查是否有新的待处理数据
      _this.isDecoding = false;
      if (_this.pendingRawData) {
        // 有新数据到达,立即处理
        _this.processPendingData();
      }
    };
  }

  switchCamera(flag) {
    this.camera_flag = flag;
    this._needsRender = true;
  }

  ShowDriveMode(showDriveMode) {
    this._needsRender = true;
    this.setState({
      showDriveMode,
    });
  }

  getCurrentTime() {
    if (this.deque_dataview.length > 0) {
      let data_msg = this.deque_dataview.shift();
      let diff_secs = (data_msg.current_time - data_msg.time / 1000000) / 1000;
      return parseFloat(diff_secs.toFixed(3));
    } else {
      return -1;
    }
  }

  updateControlTarget() {
    let eyesight;
    let car_offset = new THREE.Vector3(5, 0, 0);
    car_offset.applyQuaternion(this.quaternion_vehicle);
    let car_pos = new THREE.Vector3(this.current_x, this.current_y, 0);
    let car_shadow_pos = new THREE.Vector3(0, 0, 0);
    car_shadow_pos.addVectors(car_pos, car_offset);

    if (this.camera_flag === 0 || this.camera_flag === 1) {
      if (this.camera_flag === 0) eyesight = new THREE.Vector3(-1, 0, 0.5);
      else eyesight = new THREE.Vector3(-0.00001, 0, 1);
      eyesight.applyQuaternion(this.quaternion_vehicle);
      eyesight.normalize();
      let fscale;
      if (this.camera_last_flag !== this.camera_flag) {
        if (this.camera_flag === 0) fscale = this.camera_scale_follow;
        else fscale = this.camera_scale_top;
      } else {
        fscale = this.controls.object.position.z / eyesight.z; //50;
        if (this.camera_flag === 0) this.camera_scale_follow = fscale;
        else this.camera_scale_top = fscale;
      }
      this.camera_last_flag = this.camera_flag;
      eyesight.multiplyScalar(fscale); //向量相乘

      let target = car_shadow_pos;
      let pos = new THREE.Vector3(0, 0, 0);
      pos.addVectors(target, eyesight);

      this.controls.object.position.set(pos.x, pos.y, pos.z);
      this.controls.target = target;
      this.controls.object.up.set(0, 0, 1);
    } else if (this.camera_flag === 2) {
      this.camera_last_flag = this.camera_flag;
      eyesight = new THREE.Vector3(-5, 0, 1);
      eyesight.applyQuaternion(this.quaternion_vehicle);
      eyesight.normalize();
      let fscale = 10;
      eyesight.setX(-eyesight.x);
      eyesight.setY(-eyesight.y);
      eyesight.setZ(-eyesight.z);
      let car_location_offset = new THREE.Vector3(
        eyesight.x,
        eyesight.y,
        eyesight.z
      );
      eyesight.multiplyScalar(fscale);
      let car_location = new THREE.Vector3(this.current_x, this.current_y, 1.5);
      let pos = new THREE.Vector3(0, 0, 0);
      pos.addVectors(car_location, eyesight);
      this.controls.object.position.set(
        this.current_x + car_location_offset.x,
        this.current_y + car_location_offset.y,
        1.5
      );
      this.controls.target = pos;
      this.controls.object.up.set(0, 0, 1);
    }
  }
  changeShowAllLight() {
    this.setState({ showAllLight: !this.state.showAllLight });
  }
  updateViewMcp(mcp_data) {
    let global_weather = mcp_data.scWeatherType;
    let global_time = mcp_data.scTimeType;
    let global_region = mcp_data.scRegionType;
    this.setState({ global_weather, global_time, global_region });
  }
  update_show_global_config() {
    let show_global_config = this.state.show_global_config;
    this.setState({ show_global_config: !show_global_config });
  }
  update_show_rmp_config(){
    let show_rmp_config = this.state.show_rmp_config;
    this.setState({ show_rmp_config: !show_rmp_config });
  }
  render() {
    const { carNumber, token, url } = this.props;
    const { 
      show_global_config, 
      global_weather, 
      global_time, 
      global_region, 
      show_rmp_config, 
      show_occ,
      show_cube,
      show_solid,
      show_single_dashed,
      show_double_dashed,
      show_crosswalk,
      show_stopLine,
      show_lane,
      show_drivable_area 
    } = this.state;
    this.wsUrl = url;
    this.vehicleSn = carNumber;
    this.vehicleDataType = 'VEHICLE_DATA';
    this.token = token;
    return (
      <div id={this.props.elementId || 'WebGL-output'}>
        <div className="timelabel_text">
          {this.state.text_current_frame_time}
        </div>
        <WebsocketCmp
          url={this.wsUrl}
          onOpen={this.verifyToken.bind(this)}
          onMessage={this.handleData.bind(this)}
          onClose={this.handleClose.bind(this)}
          sendData={this.props.sendData && JSON.stringify(this.props.sendData)}
        />
        {!this.props.hiddenCarInfo && (
          <>
            <div className="global_config">
              <div
                className="contral_icon"
                onClick={this.update_show_global_config.bind(this)}
              >
                <img
                  src={show_global_config ? RETRSCT : EXPAND}
                  alt="收起更多"
                />
              </div>
              <div
                className="global_config_data"
                style={{ display: show_global_config ? 'block' : 'none' }}
              >
                {
                  <div className="config_data_item">
                    <div className="config_item_icon">
                      <img
                        src={
                          global_weather === 0
                            ? NODATA
                            : global_weather === 1
                              ? RAIN
                              : global_weather === 2
                                ? CLEARDAY
                                : SNOW
                        }
                        alt="icon"
                      />
                    </div>
                    <div className="config_item_text">
                      {global_weather === 0
                        ? '天气'
                        : global_weather === 1
                          ? '雨'
                          : global_weather === 2
                            ? '晴'
                            : '雪'}
                    </div>
                  </div>
                }
                {
                  <div className="config_data_item">
                    <div className="config_item_icon">
                      <img
                        src={
                          global_time === 0
                            ? NODATA
                            : global_time === 1
                              ? DAY
                              : NIGHT
                        }
                        alt="icon"
                      />
                    </div>
                    <div className="config_item_text">
                      {global_time === 0
                        ? '时间'
                        : global_time === 1
                          ? '白天'
                          : '黑夜'}
                    </div>
                  </div>
                }
                {
                  <div className="config_data_item">
                    <div className="config_item_icon">
                      <img
                        src={
                          global_region === 0
                            ? NODATA
                            : global_region === 1
                              ? CONSTRUCTION
                              : ACCUMULATED_WATEWR
                        }
                        alt="icon"
                      />
                    </div>
                    <div className="config_item_text">
                      {global_region === 0
                        ? '路面'
                        : global_region === 1
                          ? '施工'
                          : '积水'}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className='rmp_switch'>
              <div
                className="contral_icon"
                onClick={this.update_show_rmp_config.bind(this)}
              >
                <img
                  src={show_rmp_config ? RETRSCT : EXPAND}
                  alt="收起更多"
                />
              </div>
              <div
                className="rmp_config_data"
                style={{ display: show_rmp_config ? 'block' : 'none' }}
              >
                <Form.Item label="O C C">
                  <Switch size="small" checked={show_occ} onChange={checked=>{
                    this.setLocalStorageState('show_occ', checked);
                    this.setState({show_occ: checked});
                  }}/>
                </Form.Item>
                <Form.Item label=" 路 沿 ">
                  <Switch size="small" checked={show_cube} onChange={checked=>{
                    this.setLocalStorageState('show_cube', checked);
                    this.setState({show_cube: checked});
                  }}/>
                </Form.Item>
                <Form.Item label=" 虚 线 ">
                  <Switch size="small" checked={show_solid} onChange={checked=>{
                    this.setLocalStorageState('show_solid', checked);
                    this.setState({show_solid: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="单实线">
                  <Switch size="small" checked={show_single_dashed} onChange={checked=>{
                    this.setLocalStorageState('show_single_dashed', checked);
                    this.setState({show_single_dashed: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="双实线">
                  <Switch size="small" checked={show_double_dashed} onChange={checked=>{
                    this.setLocalStorageState('show_double_dashed', checked);
                    this.setState({show_double_dashed: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="人行道">
                  <Switch size="small" checked={show_crosswalk} onChange={checked=>{
                    this.setLocalStorageState('show_crosswalk', checked);
                    this.setState({show_crosswalk: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="停止线">
                  <Switch size="small" checked={show_stopLine} onChange={checked=>{
                    this.setLocalStorageState('show_stopLine', checked);
                    this.setState({show_stopLine: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="中心线">
                  <Switch size="small" checked={show_lane} onChange={checked=>{
                    this.setLocalStorageState('show_lane', checked);
                    this.setState({show_lane: checked});
                  }}/>
                </Form.Item>
                <Form.Item label="可行域">
                  <Switch size="small" checked={show_drivable_area} onChange={checked=>{
                    this.setLocalStorageState('show_drivable_area', checked);
                    this.setState({show_drivable_area: checked});
                  }}/>
                </Form.Item>
              </div>
            </div>
            <div className="CarInfo">
              <div
                className="light_button"
                onClick={this.changeShowAllLight.bind(this)}
              >
                {this.state.showAllLight ? (
                  <img
                    src={BUTTOM}
                    alt="收起"
                    clstag={clstagStr(CLSTAG.CollapseTrafficLight)}
                  />
                ) : (
                  <img
                    src={TOP}
                    alt="展开"
                    clstag={clstagStr(CLSTAG.ExpandTrafficLight)}
                  />
                )}
              </div>
              <div className="lightList">
                {(() => {
                  // 判断是否为新版数据：perceptionLightInfoList始终有5个灯型
                  const isNewVersion = this.state.perceptionLightInfoList.length === 5;
                  
                  if (isNewVersion) {
                    // 新版渲染逻辑：收起显示PNC结果，展开显示感知结果
                    const displayList = this.state.showAllLight 
                      ? this.state.perceptionLightInfoList 
                      : this.state.lightInfoList;
                    
                    if (!displayList || displayList.length === 0) {
                      return null;
                    }
                    
                    return displayList.map((item, index) => (
                      <div key={index} className="light_item">
                        <div className="light_direction">{item.turnType || '未知'}</div>
                        <div className="light_lamp">
                          <div className={item.style_text_red} />
                          <div className={item.style_text_green} />
                          <div className={item.style_text_yellow} />
                        </div>
                      </div>
                    ));
                  } else {
                    // 旧版渲染逻辑：收起显示第1个，展开显示全部，无数据显示黑灯
                    if (this.state.lightInfoList.length > 0) {
                      if (this.state.showAllLight) {
                        // 展开显示全部
                        return this.state.lightInfoList.map((item, index) => {
                          return (
                            <div key={index} className="light_container">
                              <div className="light_information">
                                <span className="light_id">{item.id}</span>
                                <span className="light_duration">
                                  {item.duration.toFixed(2)}
                                </span>
                              </div>
                              <div className="light_stateText">
                                {item.trafficLightStateText}
                              </div>
                              <div className="light">
                                <div className={item.style_text_red} />
                                <div className={item.style_text_green} />
                                <div className={item.style_text_yellow} />
                              </div>
                            </div>
                          );
                        });
                      } else {
                        // 收起显示第1个
                        return (
                          <div className="light_container">
                            <div className="light_information">
                              <span className="light_id">
                                {this.state.lightInfoList[0].id}
                              </span>
                              <span className="light_duration">
                                {this.state.lightInfoList[0].duration.toFixed(2)}
                              </span>
                            </div>
                            <div className="light_stateText">
                              {this.state.lightInfoList[0].trafficLightStateText}
                            </div>
                            <div className="light">
                              <div className={this.state.lightInfoList[0].style_text_red} />
                              <div className={this.state.lightInfoList[0].style_text_green} />
                              <div className={this.state.lightInfoList[0].style_text_yellow} />
                            </div>
                          </div>
                        );
                      }
                    } else {
                      // 无数据显示黑灯
                      return (
                        <div className="light_container">
                          <div className="light_none">
                            <div />
                            <div />
                            <div />
                          </div>
                        </div>
                      );
                    }
                  }
                })()}
              </div>
              {this.state.showDriveMode ? (
                <div className="car_info">
                  <div className="car_img">
                    <img src={SteeringWheel} alt="机车方向盘" />
                  </div>
                  <div className="car_steer_text">{this.state.steerAngle}</div>
                  <div className="car_gear_text">
                    {this.state.carGearPosition}
                  </div>
                  <div className="car_pole_text">
                    {this.state.poleIsClose ? 'POLE_CLOSE' : 'POLE_LIFTED'}
                  </div>
                </div>
              ) : null}
            </div>
          </>
        )}
      </div>
    );
  }
}

export default ThreeMonitor;